import React, { useEffect, useState } from 'react';
import { getStoreInfo, updateStoreSettings } from '../services/api';
import { getAuth } from '../services/auth';
import Pagination from '../components/Pagination'; // <--- PAGINAÇÃO IMPORTADA
import {
    LayoutDashboard, Package, Settings, LogOut, Menu, X,
    Plus, Edit, Edit2, Trash2, TrendingUp, DollarSign, ShoppingBag,
    Image, Layers, Box, Tag, ChevronRight, BarChart3, Clock, CheckCircle,
    Search, Filter, Calendar, ListOrdered, Users, User, ArrowUpRight, Globe, XCircle,
    Bot, BotOff, CreditCard, Truck, MessageCircle, Save, MapPin, TicketPercent, Bike, Send, Share2, HelpCircle, Check, AlertCircle, QrCode, RefreshCw, FileText, Store
} from 'lucide-react';
import { API_BASE_URL } from '../constants';
import axios from 'axios';
import { useToast } from '../context/ToastContext';
import { useConfirm } from '../context/ConfirmContext';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip as ChartTooltip, Legend, Filler } from 'chart.js';

// --- IMPORTAÇÕES DE COMPONENTES EXTERNOS ---
import TrackingModal from '../components/TrackingModal';
import DispatchModal from '../components/DispatchModal';
import ShareModal from '../components/ShareModal';
import TagsModal from '../components/TagsModal';
import CampaignModal from '../components/CampaignModal';
import AdminProducts from './AdminProducts';
import CampaignHistory from '../components/CampaignHistory';
import ImageCropperModal from '../components/ImageCropperModal';
import TermsOfUseModal from '../components/TermsOfUseModal';
import SupportPage from './SupportPage';
import AdminSupportPage from './AdminSupportPage';
import PromptsTab from '../components/PromptsTab';
import OrderDetailsModal from '../components/OrderDetailsModal';


ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, ChartTooltip, Legend, Filler);

// --- DESIGN SYSTEM UI COMPONENTS ---
const Card = ({ children, className = '' }: any) => (
    <div className={`bg-white rounded-2xl shadow-sm border border-surface-200 overflow-hidden ${className}`}>{children}</div>
);

const Badge = ({ children, color = 'gray' }: any) => {
    const colors: any = {
        green: 'bg-emerald-50 text-emerald-700 border-emerald-100',
        blue: 'bg-blue-50 text-blue-700 border-blue-100',
        red: 'bg-red-50 text-red-700 border-red-100',
        purple: 'bg-brand-50 text-brand-700 border-brand-100',
        orange: 'bg-orange-50 text-orange-700 border-orange-100',
        gray: 'bg-gray-50 text-gray-600 border-gray-100'
    };
    return <span className={`px-2.5 py-1 rounded-lg text-xs font-bold border ${colors[color] || colors.gray}`}>{children}</span>;
};

// --- GRÁFICOS ---
const SalesChart = ({ data }: { data: any[] }) => {
    const chartData = {
        labels: data.map(d => d.date),
        datasets: [{
            label: 'Vendas (R$)',
            data: data.map(d => Number(d.total)),
            borderColor: '#4f46e5',
            backgroundColor: 'rgba(79, 70, 229, 0.1)',
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#fff',
            pointBorderColor: '#4f46e5',
            pointBorderWidth: 2,
            pointRadius: 4,
        }]
    };
    const options = { responsive: true, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, grid: { display: false } }, x: { grid: { display: false } } } };
    return <Card className="p-6 col-span-2"><h3 className="font-bold text-lg mb-4 text-surface-900 flex items-center gap-2"><TrendingUp size={20} className="text-brand-500" /> Performance de Vendas</h3><div className="h-64"><Line data={chartData} options={options} /></div></Card>;
};

// --- MODAIS ESPECÍFICOS DO DASHBOARD ---

// 1. Modal de Cupons
const CouponModal = ({ tenantId, onClose, onSuccess, initialData = null }: any) => {
    const { showToast } = useToast();
    const [form, setForm] = useState({
        code: initialData?.code || '',
        discount_type: initialData?.discount_type || 'PERCENTAGE',
        discount_value: initialData?.discount_value || '',
        min_purchase: initialData?.min_purchase || '',
        usage_limit: initialData?.usage_limit || '',
        expires_at: initialData?.expires_at ? initialData.expires_at.split('T')[0] : '',
        included_product_ids: initialData?.included_product_ids || [] as string[],
        excluded_product_ids: initialData?.excluded_product_ids || [] as string[],
        included_category_ids: initialData?.included_category_ids || [] as string[],
        excluded_category_ids: initialData?.excluded_category_ids || [] as string[],
        apply_to_all: initialData ? (initialData.included_product_ids?.length === 0 && initialData.included_category_ids?.length === 0) : true,
        single_use_per_customer: initialData?.single_use_per_customer !== undefined ? initialData.single_use_per_customer : true
    });
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState<any[]>([]);
    const [categories, setCategories] = useState<any[]>([]);
    const [search, setSearch] = useState('');
    const [showDropdown, setShowDropdown] = useState<'included' | 'excluded' | null>(null);
    const [showAdvanced, setShowAdvanced] = useState(false);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const [prodRes, catRes] = await Promise.all([
                    axios.get(`https://zapshop.app/api/store/${tenantId}/products`),
                    axios.get(`https://zapshop.app/api/categories/${tenantId}`)
                ]);
                setProducts(prodRes.data);
                setCategories(catRes.data);
            } catch (e) { console.error(e); }
        };
        loadInitialData();
    }, [tenantId]);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (parseFloat(form.discount_value) <= 0) return showToast('O valor do desconto deve ser maior que zero.', 'error');

        setLoading(true);
        try {
            const payload = {
                ...form,
                tenant_id: tenantId,
                included_product_ids: form.apply_to_all ? [] : form.included_product_ids,
                included_category_ids: form.apply_to_all ? [] : form.included_category_ids
            };
            if (initialData?.id) {
                await axios.put(`https://zapshop.app/api/coupons/${initialData.id}`, payload);
                showToast('Cupom atualizado com sucesso!', 'success');
            } else {
                await axios.post('https://zapshop.app/api/coupons', payload);
                showToast('Cupom criado com sucesso!', 'success');
            }
            onSuccess(); onClose();
        } catch (e: any) {
            showToast(e.response?.data?.error || 'Erro ao salvar cupom', 'error');
        } finally { setLoading(false); }
    };

    const toggleItem = (id: string, type: 'included' | 'excluded', target: 'product' | 'category') => {
        const field = `${type}_${target}_ids` as keyof typeof form;
        const currentList = form[field] as string[];

        if (currentList.includes(id)) {
            setForm({ ...form, [field]: currentList.filter(item => item !== id) });
        } else {
            const otherType = type === 'included' ? 'excluded' : 'included';
            const otherField = `${otherType}_${target}_ids` as keyof typeof form;
            const otherList = form[otherField] as string[];

            setForm({
                ...form,
                [field]: [...currentList, id],
                [otherField]: otherList.filter(item => item !== id)
            });
        }
    };

    const filteredProducts = products.filter(p => p.name.toLowerCase().includes(search.toLowerCase())).slice(0, 5);
    const filteredCategories = categories.filter(c => c.name.toLowerCase().includes(search.toLowerCase())).slice(0, 5);

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6 max-h-[90vh] overflow-y-auto custom-scrollbar">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-bold text-lg">{initialData ? 'Editar Cupom' : 'Novo Cupom de Desconto'}</h3>
                    <button onClick={onClose} className="p-1 hover:bg-surface-100 rounded-lg"><X size={20} className="text-gray-400" /></button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="bg-surface-50 p-4 rounded-xl border border-surface-100 space-y-4">
                        <div>
                            <label className="text-xs font-bold text-gray-500 uppercase">Código do Cupom</label>
                            <input required className="input-primary uppercase font-mono mt-1" value={form.code} onChange={e => setForm({ ...form, code: e.target.value.toUpperCase().replace(/\s/g, '') })} placeholder="EX: BEMVINDO10" />
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="text-xs font-bold text-gray-500 uppercase">Tipo de Desconto</label>
                                <select className="input-primary mt-1" value={form.discount_type} onChange={e => setForm({ ...form, discount_type: e.target.value })}>
                                    <option value="PERCENTAGE">% Porcentagem</option>
                                    <option value="FIXED">R$ Valor Fixo</option>
                                </select>
                            </div>
                            <div>
                                <label className="text-xs font-bold text-gray-500 uppercase">Valor</label>
                                <input required type="number" step="0.01" className="input-primary mt-1" value={form.discount_value} onChange={e => setForm({ ...form, discount_value: e.target.value })} placeholder="0.00" />
                            </div>
                        </div>
                    </div>

                    <div className="border-t border-surface-100 pt-2">
                        <button type="button" onClick={() => setShowAdvanced(!showAdvanced)} className="flex items-center justify-between w-full py-2 text-sm font-bold text-brand-600 hover:text-brand-700 transition">
                            <span>{showAdvanced ? '− Ocultar Opções Avançadas' : '+ Mostrar Opções Avançadas'}</span>
                        </button>

                        {showAdvanced && (
                            <div className="space-y-4 mt-2 animate-slide-down">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="text-xs font-bold text-gray-500 uppercase">Pedido Mínimo (R$)</label>
                                        <input type="number" step="0.01" className="input-primary mt-1" value={form.min_purchase} onChange={e => setForm({ ...form, min_purchase: e.target.value })} placeholder="0.00" />
                                    </div>
                                    <div>
                                        <label className="text-xs font-bold text-gray-500 uppercase">Limite Global de Usos</label>
                                        <input type="number" className="input-primary mt-1" value={form.usage_limit} onChange={e => setForm({ ...form, usage_limit: e.target.value })} placeholder="∞" />
                                    </div>
                                </div>

                                <div>
                                    <label className="text-xs font-bold text-gray-500 uppercase">Data de Validade</label>
                                    <input type="date" className="input-primary mt-1" value={form.expires_at} onChange={e => setForm({ ...form, expires_at: e.target.value })} />
                                </div>
                                
                                <label className="flex items-center gap-2 cursor-pointer mt-3 mb-2 p-1 hover:bg-surface-50 rounded transition">
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 text-brand-600 rounded border-gray-300 focus:ring-brand-500"
                                        checked={form.single_use_per_customer}
                                        onChange={e => setForm({ ...form, single_use_per_customer: e.target.checked })}
                                    />
                                    <span className="text-sm font-bold text-gray-700">Permitir apenas 1 uso por cliente</span>
                                </label>

                                <div className="space-y-4 pt-2">
                                    {/* INCLUSÃO */}
                                    <div className="bg-white p-3 rounded-lg border border-surface-100">
                                        <label className="flex items-center gap-2 cursor-pointer mb-3 p-1 hover:bg-surface-50 rounded transition">
                                            <input
                                                type="checkbox"
                                                className="w-4 h-4 text-brand-600 rounded border-gray-300 focus:ring-brand-500"
                                                checked={form.apply_to_all}
                                                onChange={e => setForm({ ...form, apply_to_all: e.target.checked })}
                                            />
                                            <span className="text-sm font-bold text-gray-700">Aplicar desconto a todos os produtos da loja</span>
                                        </label>

                                        {!form.apply_to_all && (
                                            <div className="animate-slide-down space-y-3">
                                                <label className="text-xs font-bold text-emerald-600 uppercase flex items-center gap-1"><Plus size={14} /> Aplicar apenas em (Produtos ou Categorias)</label>
                                                <div className="relative mt-1">
                                                    <input
                                                        type="text"
                                                        className="input-primary text-sm"
                                                        placeholder="Buscar produto ou categoria..."
                                                        value={showDropdown === 'included' ? search : ''}
                                                        onChange={e => { setSearch(e.target.value); setShowDropdown('included'); }}
                                                        onFocus={() => setShowDropdown('included')}
                                                    />
                                                    {showDropdown === 'included' && search.length > 0 && (
                                                        <div className="absolute z-10 w-full mt-1 bg-white border border-surface-200 rounded-lg shadow-lg overflow-hidden max-h-60 overflow-y-auto">
                                                            {filteredCategories.length > 0 && (
                                                                <div className="px-2 py-1 bg-surface-50 text-[10px] font-bold text-gray-400 uppercase font-bold">Categorias</div>
                                                            )}
                                                            {filteredCategories.map(c => (
                                                                <div key={c.id} onClick={() => { toggleItem(c.id, 'included', 'category'); setShowDropdown(null); setSearch(''); }} className="p-2 hover:bg-emerald-50 cursor-pointer flex items-center justify-between">
                                                                    <div className="flex items-center gap-2">
                                                                        <Layers size={14} className="text-emerald-500" />
                                                                        <span className="text-xs font-bold">{c.name} {form.included_category_ids.includes(c.id) && '✅'}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            {filteredProducts.length > 0 && (
                                                                <div className="px-2 py-1 bg-surface-50 text-[10px] font-bold text-gray-400 uppercase font-bold border-t border-surface-100">Produtos</div>
                                                            )}
                                                            {filteredProducts.map(p => (
                                                                <div key={p.id} onClick={() => { toggleItem(p.id, 'included', 'product'); setShowDropdown(null); setSearch(''); }} className="p-2 hover:bg-emerald-50 cursor-pointer flex items-center justify-between">
                                                                    <div className="flex items-center gap-2">
                                                                        {p.image_url && <img src={p.image_url.startsWith('http') ? p.image_url : `https://zapshop.app/api${p.image_url}`} className="w-6 h-6 rounded object-cover" />}
                                                                        <span className="text-xs">{p.name} {form.included_product_ids.includes(p.id) && '✅'}</span>
                                                                    </div>
                                                                    <span className="text-[10px] font-bold text-gray-400">R$ {p.price}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="flex flex-wrap gap-2 mt-2">
                                                    {form.included_category_ids.map(id => {
                                                        const c = categories.find(cat => cat.id === id);
                                                        return c ? (
                                                            <span key={id} className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-50 text-blue-700 text-[10px] font-bold rounded-lg border border-blue-100">
                                                                <Layers size={10} /> {c.name} <button type="button" onClick={() => toggleItem(id, 'included', 'category')}><X size={10} /></button>
                                                            </span>
                                                        ) : null;
                                                    })}
                                                    {form.included_product_ids.map(id => {
                                                        const p = products.find(prod => prod.id === id);
                                                        return p ? (
                                                            <span key={id} className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-50 text-emerald-700 text-[10px] font-bold rounded-lg border border-emerald-100">
                                                                {p.name} <button type="button" onClick={() => toggleItem(id, 'included', 'product')}><X size={10} /></button>
                                                            </span>
                                                        ) : null;
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* EXCLUSÃO */}
                                    <div>
                                        <label className="text-xs font-bold text-red-600 uppercase flex items-center gap-1"><X size={14} /> Excluir desconto de (Produtos ou Categorias)</label>
                                        <div className="relative mt-1">
                                            <input
                                                type="text"
                                                className="input-primary text-sm"
                                                placeholder="Buscar produto ou categoria para excluir..."
                                                value={showDropdown === 'excluded' ? search : ''}
                                                onChange={e => { setSearch(e.target.value); setShowDropdown('excluded'); }}
                                                onFocus={() => setShowDropdown('excluded')}
                                            />
                                            {showDropdown === 'excluded' && search.length > 0 && (
                                                <div className="absolute z-10 w-full mt-1 bg-white border border-surface-200 rounded-lg shadow-lg overflow-hidden max-h-60 overflow-y-auto">
                                                    {filteredCategories.length > 0 && (
                                                        <div className="px-2 py-1 bg-surface-50 text-[10px] font-bold text-gray-400 uppercase font-bold">Categorias</div>
                                                    )}
                                                    {filteredCategories.map(c => (
                                                        <div key={c.id} onClick={() => { toggleItem(c.id, 'excluded', 'category'); setShowDropdown(null); setSearch(''); }} className="p-2 hover:bg-red-50 cursor-pointer flex items-center justify-between">
                                                            <div className="flex items-center gap-2">
                                                                <Layers size={14} className="text-red-500" />
                                                                <span className="text-xs font-bold">{c.name} {form.excluded_category_ids.includes(c.id) && '🚫'}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {filteredProducts.length > 0 && (
                                                        <div className="px-2 py-1 bg-surface-50 text-[10px] font-bold text-gray-400 uppercase font-bold border-t border-surface-100">Produtos</div>
                                                    )}
                                                    {filteredProducts.map(p => (
                                                        <div key={p.id} onClick={() => { toggleItem(p.id, 'excluded', 'product'); setShowDropdown(null); setSearch(''); }} className="p-2 hover:bg-red-50 cursor-pointer flex items-center justify-between">
                                                            <div className="flex items-center gap-2">
                                                                {p.image_url && <img src={p.image_url.startsWith('http') ? p.image_url : `https://zapshop.app/api${p.image_url}`} className="w-6 h-6 rounded object-cover" />}
                                                                <span className="text-xs">{p.name} {form.excluded_product_ids.includes(p.id) && '🚫'}</span>
                                                            </div>
                                                            <span className="text-[10px] font-bold text-gray-400">R$ {p.price}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex flex-wrap gap-2 mt-2">
                                            {form.excluded_category_ids.map(id => {
                                                const c = categories.find(cat => cat.id === id);
                                                return c ? (
                                                    <span key={id} className="inline-flex items-center gap-1 px-2 py-0.5 bg-red-50 text-red-700 text-[10px] font-bold rounded-lg border border-red-100">
                                                        <Layers size={10} /> {c.name} <button type="button" onClick={() => toggleItem(id, 'excluded', 'category')}><X size={10} /></button>
                                                    </span>
                                                ) : null;
                                            })}
                                            {form.excluded_product_ids.map(id => {
                                                const p = products.find(prod => prod.id === id);
                                                return p ? (
                                                    <span key={id} className="inline-flex items-center gap-1 px-2 py-0.5 bg-red-50 text-red-700 text-[10px] font-bold rounded-lg border border-red-100">
                                                        {p.name} <button type="button" onClick={() => toggleItem(id, 'excluded', 'product')}><X size={10} /></button>
                                                    </span>
                                                ) : null;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex gap-3 pt-4 border-t border-surface-100">
                        <button type="button" onClick={onClose} className="btn-secondary flex-1 py-3">Cancelar</button>
                        <button disabled={loading} className="btn-primary flex-1 py-3 shadow-lg shadow-brand-200">{loading ? '...' : 'Salvar Cupom'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// --- ABAS ---

// 1. Visão Geral
const OverviewTab = ({ stats, tenantId, onOpenOrderDetails }: any) => {
    const [orders, setOrders] = useState<any[]>([]);
    const [chartData, setChartData] = useState<any[]>([]);
    const [products, setProducts] = useState<any[]>([]);
    const [sortOrder, setSortOrder] = useState('desc');

    useEffect(() => {
        if (tenantId) {
            const fetchData = async () => {
                try {
                    const [ordersRes, salesRes, prodRes] = await Promise.all([
                        axios.get(`https://zapshop.app/api/orders/${tenantId}`), // Mantém rota antiga para pegar últimos 5
                        axios.get(`https://zapshop.app/api/reports/sales/${tenantId}`),
                        axios.get(`https://zapshop.app/api/reports/products-performance/${tenantId}?sort=${sortOrder}`)
                    ]);
                    // Pega apenas os 5 ultimos
                    setOrders(ordersRes.data.filter((o: any) => o.status !== 'COMPLETED' && o.status !== 'CANCELLED').slice(0, 5));
                    setChartData(Array.isArray(salesRes.data) ? salesRes.data.slice(-7) : []);
                    setProducts(prodRes.data.slice(0, 5));
                } catch (e) { console.error(e); }
            };
            fetchData();
        }
    }, [tenantId, sortOrder]);

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
                <Card className="p-4 md:p-6 relative overflow-hidden group">
                    <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity"><DollarSign size={40} /></div>
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1">Faturamento</p>
                    <h3 className="text-xl font-bold text-surface-900">R$ {Number(stats.sales).toFixed(2)}</h3>
                </Card>
                <Card className="p-4 md:p-6">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1">Pedidos</p>
                    <h3 className="text-xl font-bold text-surface-900">{stats.orders}</h3>
                </Card>
                <Card className="p-4 md:p-6">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1">Produtos</p>
                    <h3 className="text-xl font-bold text-surface-900">{stats.products}</h3>
                </Card>
                <Card className="p-4 md:p-6">
                    <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1">Ticket Médio</p>
                    <h3 className="text-xl font-bold text-brand-600">R$ {stats.orders ? (stats.sales / stats.orders).toFixed(2) : '0.00'}</h3>
                </Card>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2"><SalesChart data={chartData} /></div>
                <Card className="p-6 flex flex-col">
                    <h3 className="font-bold text-lg mb-6 flex items-center gap-2"><Clock size={18} className="text-brand-500" /> Últimas Atividades</h3>
                    <div className="space-y-4 flex-1 overflow-y-auto pr-2 custom-scrollbar max-h-[300px]">
                        {orders.length === 0 ? (
                            <div className="flex flex-col items-center justify-center h-full text-center text-gray-400">
                                <CheckCircle size={32} className="mb-2 opacity-20" />
                                <p className="text-sm">Nenhum pedido recente.</p>
                            </div>
                        ) : orders.map(o => (
                            <div key={o.id} className="flex items-center gap-3 p-3 rounded-xl bg-surface-50 border border-surface-100 hover:bg-surface-100/50 transition cursor-pointer" onClick={() => onOpenOrderDetails(o)}>
                                <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-700 font-bold text-[10px]">#{o.id.slice(0, 3)}</div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-1.5 flex-wrap">
                                        <p className="font-bold text-sm text-surface-900">R$ {Number(o.total_amount).toFixed(2)}</p>
                                        {o.shipping_type === 'PICKUP' ? <Store size={12} className="text-orange-500" /> : <Truck size={12} className="text-blue-500" />}
                                    </div>
                                    <p className="text-[10px] text-gray-500 truncate">
                                        {o.items?.[0]?.name || 'Pedido'}
                                        {o.items?.length > 1 && ` + ${o.items.length - 1} itens`}
                                    </p>
                                </div>
                                <Badge color={o.status === 'PAID' ? 'green' : o.status === 'PENDING' ? 'orange' : o.status === 'SHIPPED' ? 'blue' : o.status === 'DELIVERED' ? 'gray' : 'red'}>
                                    {o.status === 'PAID' ? 'PAGO' : o.status === 'PENDING' ? 'PENDENTE' : o.status === 'SHIPPED' ? 'ENVIADO' : o.status === 'DELIVERED' ? 'ENTREGUE' : 'CANCELADO'}
                                </Badge>
                            </div>
                        ))}
                    </div>
                </Card>
            </div>

            <Card>
                <div className="p-4 md:p-6 border-b border-surface-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-surface-50/50">
                    <h3 className="font-bold text-surface-900 flex items-center gap-2"><ListOrdered size={20} /> Ranking de Produtos</h3>
                    <select className="input-primary w-full sm:w-auto py-1.5 text-xs" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
                        <option value="desc">🏆 Mais Vendidos</option>
                        <option value="asc">🐢 Encalhados</option>
                    </select>
                </div>
                <table className="w-full text-left">
                    <thead className="bg-white border-b border-surface-100 text-[10px] font-bold text-gray-400 uppercase">
                        <tr><th className="p-3">Produto</th><th className="p-3">Qtd</th><th className="p-3">Receita</th></tr>
                    </thead>
                    <tbody className="divide-y divide-surface-100">
                        {products.length === 0 ? (
                            <tr><td colSpan={3} className="p-6 text-center text-gray-400 text-xs">Sem dados.</td></tr>
                        ) : products.map((p: any, idx: number) => (
                            <tr key={idx} className="hover:bg-surface-50">
                                <td className="p-3 text-xs font-medium text-surface-900 truncate max-w-[140px]">{p.name}</td>
                                <td className="p-3 text-xs font-bold text-brand-600">{p.quantity}</td>
                                <td className="p-3 text-[11px] text-gray-500">R$ {Number(p.revenue).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </Card>
        </div>
    );
};

// 1.5 Modal de Pedido Manual
const ManualOrderModal = ({ tenantId, onClose, onSuccess }: { tenantId: string, onClose: () => void, onSuccess: () => void }) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);

    // Autocomplete states
    const [customerSearch, setCustomerSearch] = useState('');
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

    const [productSearch, setProductSearch] = useState('');
    const [showProductDropdown, setShowProductDropdown] = useState(false);

    const [form, setForm] = useState({
        customer_name: '',
        customer_phone: '',
        customer_email: '',
        status: 'PAID',
        payment_method: 'PIX',
        description: ''
    });

    useEffect(() => {
        // Fetch products
        axios.get(`https://zapshop.app/api/store/${tenantId}/products`)
            .then(res => setProducts(res.data.filter((p: any) => p.active && p.stock > 0)))
            .catch(err => console.error("Erro ao buscar produtos", err));

        // Fetch customers for autocomplete
        axios.get(`https://zapshop.app/api/admin/store/${tenantId}/customers?limit=1000`)
            .then(res => {
                if (res.data && res.data.data) {
                    setCustomers(res.data.data);
                }
            })
            .catch(err => console.error("Erro ao buscar clientes", err));
    }, [tenantId]);

    // Derived filtered lists
    const filteredCustomers = customers.filter(c =>
        c.phone.includes(customerSearch) || c.name.toLowerCase().includes(customerSearch.toLowerCase())
    ).slice(0, 5); // show max 5

    const filteredProducts = products.filter(p =>
        p.name.toLowerCase().includes(productSearch.toLowerCase())
    ).slice(0, 5); // show max 5

    const handleSelectCustomer = (customer: any) => {
        setCustomerSearch(customer.phone);
        setForm({
            ...form,
            customer_phone: customer.phone,
            customer_name: customer.name,
            customer_email: customer.email || ''
        });
        setShowCustomerDropdown(false);
    };

    const handleSelectProduct = (product: any) => {
        const existingItem = selectedItems.find(item => item.product_id === product.id);
        if (existingItem) {
            if (existingItem.quantity < product.stock) {
                setSelectedItems(selectedItems.map(item =>
                    item.product_id === product.id ? { ...item, quantity: item.quantity + 1 } : item
                ));
            } else {
                showToast('Estoque insuficiente.', 'error');
            }
        } else {
            setSelectedItems([...selectedItems, {
                product_id: product.id,
                name: product.name,
                price: product.price,
                stock: product.stock,
                quantity: 1
            }]);
        }
        setProductSearch('');
        setShowProductDropdown(false);
    };

    const updateQuantity = (productId: string, delta: number) => {
        setSelectedItems(selectedItems.map(item => {
            if (item.product_id === productId) {
                const newQ = item.quantity + delta;
                if (newQ < 1) return item;
                if (newQ > item.stock) {
                    showToast('Estoque insuficiente.', 'error');
                    return item;
                }
                return { ...item, quantity: newQ };
            }
            return item;
        }));
    };

    const removeItem = (productId: string) => {
        setSelectedItems(selectedItems.filter(item => item.product_id !== productId));
    };

    const totalAmount = selectedItems.reduce((acc, item) => acc + (Number(item.price) * item.quantity), 0);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (selectedItems.length === 0) {
            showToast('Adicione pelo menos um produto ao pedido.', 'error');
            return;
        }

        setLoading(true);
        try {
            await axios.post(`https://zapshop.app/api/admin/store/${tenantId}/manual-order`, {
                ...form,
                total_amount: totalAmount,
                items: selectedItems
            });
            onSuccess();
            onClose();
            showToast('Pedido criado com sucesso!', 'success');
        } catch (error: any) {
            showToast(error.response?.data?.error || 'Erro ao criar pedido.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6 max-h-[90vh] overflow-y-auto custom-scrollbar">
                <div className="flex justify-between items-center mb-4 sticky top-0 bg-white z-10 pb-2 border-b border-surface-100">
                    <h3 className="font-bold text-lg text-surface-900">Novo Pedido Manual</h3>
                    <button onClick={onClose} className="p-1 hover:bg-surface-100 rounded-lg transition-colors"><X size={20} className="text-gray-400 hover:text-red-500" /></button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="bg-surface-50 p-4 rounded-xl border border-surface-100">
                        <h4 className="text-xs font-bold text-brand-600 uppercase mb-3 flex items-center gap-2"><User size={14} /> Cliente</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div className="relative">
                                <label className="text-xs font-bold text-gray-600">Celular (WhatsApp)</label>
                                <input
                                    required
                                    className="input-primary w-full mt-1"
                                    placeholder="Ex: 551199999999"
                                    value={customerSearch}
                                    onChange={e => {
                                        const val = e.target.value.replace(/\D/g, '');
                                        setCustomerSearch(val);
                                        setForm({ ...form, customer_phone: val });
                                        setShowCustomerDropdown(true);
                                    }}
                                    onFocus={() => setShowCustomerDropdown(true)}
                                    onBlur={() => setTimeout(() => setShowCustomerDropdown(false), 200)}
                                />
                                {showCustomerDropdown && customerSearch.length > 1 && filteredCustomers.length > 0 && (
                                    <div className="absolute z-20 w-full mt-1 bg-white border border-surface-200 rounded-lg shadow-lg">
                                        {filteredCustomers.map(c => (
                                            <div
                                                key={c.id}
                                                className="p-2 hover:bg-surface-50 cursor-pointer text-sm border-b border-surface-100 last:border-0"
                                                onClick={() => handleSelectCustomer(c)}
                                            >
                                                <p className="font-bold text-surface-900">{c.phone}</p>
                                                <p className="text-xs text-gray-500">{c.name}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <p className="text-[10px] text-gray-400 mt-1">O cliente será criado se não existir.</p>
                            </div>
                            <div>
                                <label className="text-xs font-bold text-gray-600">Nome</label>
                                <input required className="input-primary w-full mt-1" placeholder="Ex: João Silva" value={form.customer_name} onChange={e => setForm({ ...form, customer_name: e.target.value })} />
                            </div>
                            <div className="md:col-span-2">
                                <label className="text-xs font-bold text-gray-600">E-mail (Para Notificações)</label>
                                <input className="input-primary w-full mt-1" type="email" placeholder="cliente@email.com" value={form.customer_email} onChange={e => setForm({ ...form, customer_email: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="bg-surface-50 p-4 rounded-xl border border-surface-100">
                        <h4 className="text-xs font-bold text-brand-600 uppercase mb-3 flex items-center gap-2"><Package size={14} /> Produtos do Pedido</h4>

                        <div className="mb-4 relative">
                            <input
                                type="text"
                                className="input-primary w-full text-sm font-medium pr-10"
                                placeholder="Digite para buscar um produto..."
                                value={productSearch}
                                onChange={e => {
                                    setProductSearch(e.target.value);
                                    setShowProductDropdown(true);
                                }}
                                onFocus={() => setShowProductDropdown(true)}
                                onBlur={() => setTimeout(() => setShowProductDropdown(false), 200)}
                            />
                            <Search size={16} className="absolute right-3 top-3 text-gray-400" />

                            {showProductDropdown && productSearch.length > 0 && (
                                <div className="absolute z-20 w-full mt-1 bg-white border border-surface-200 rounded-lg shadow-lg">
                                    {filteredProducts.length > 0 ? filteredProducts.map(p => (
                                        <div
                                            key={p.id}
                                            className="p-3 hover:bg-surface-50 cursor-pointer border-b border-surface-100 last:border-0 flex justify-between items-center"
                                            onClick={() => handleSelectProduct(p)}
                                        >
                                            <div>
                                                <p className="font-bold text-sm text-surface-900">{p.name}</p>
                                                <p className="text-xs text-gray-500">Estoque: {p.stock}</p>
                                            </div>
                                            <p className="font-bold text-brand-600">R$ {Number(p.price).toFixed(2)}</p>
                                        </div>
                                    )) : (
                                        <div className="p-3 text-sm text-gray-500 text-center">Nenhum produto encontrado.</div>
                                    )}
                                </div>
                            )}
                        </div>

                        {selectedItems.length > 0 ? (
                            <div className="space-y-2 mb-4 max-h-[150px] overflow-y-auto pr-1 custom-scrollbar">
                                {selectedItems.map(item => (
                                    <div key={item.product_id} className="flex items-center justify-between p-2 bg-white rounded-lg border border-surface-200 shadow-sm">
                                        <div className="flex-1 truncate pr-2">
                                            <p className="text-xs font-bold text-surface-900 truncate">{item.name}</p>
                                            <p className="text-[10px] text-brand-600 font-semibold">R$ {Number(item.price).toFixed(2)}</p>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <div className="flex items-center bg-surface-50 rounded-lg border border-surface-200">
                                                <button type="button" onClick={() => updateQuantity(item.product_id, -1)} className="px-2 py-1 text-gray-500 hover:text-brand-600 hover:bg-surface-100 rounded-l-lg transition-colors">-</button>
                                                <span className="text-xs font-bold w-6 text-center">{item.quantity}</span>
                                                <button type="button" onClick={() => updateQuantity(item.product_id, 1)} className="px-2 py-1 text-gray-500 hover:text-brand-600 hover:bg-surface-100 rounded-r-lg transition-colors">+</button>
                                            </div>
                                            <button type="button" onClick={() => removeItem(item.product_id)} className="p-1 text-gray-400 hover:text-red-500 transition-colors bg-red-50 rounded"><X size={14} /></button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-4 bg-white rounded-lg border border-dashed border-surface-200 mb-4">
                                <p className="text-xs text-gray-400">Nenhum produto selecionado.</p>
                            </div>
                        )}

                        <div className="flex justify-between items-center pt-3 border-t border-surface-200">
                            <span className="text-sm font-bold text-gray-500">Total do Pedido:</span>
                            <span className="text-lg font-black text-brand-600">R$ {totalAmount.toFixed(2)}</span>
                        </div>
                    </div>

                    <div className="bg-surface-50 p-4 rounded-xl border border-surface-100">
                        <h4 className="text-xs font-bold text-brand-600 uppercase mb-3 flex items-center gap-2"><CreditCard size={14} /> Detalhes</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                            <div>
                                <label className="text-xs font-bold text-gray-600">Status</label>
                                <select className="input-primary w-full mt-1" value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                                    <option value="PAID">Pago</option>
                                    <option value="PENDING">Pendente</option>
                                    <option value="SHIPPED">Enviado</option>
                                    <option value="DELIVERED">Entregue</option>
                                </select>
                            </div>
                            <div>
                                <label className="text-xs font-bold text-gray-600">Método</label>
                                <select className="input-primary w-full mt-1" value={form.payment_method} onChange={e => setForm({ ...form, payment_method: e.target.value })}>
                                    <option value="PIX">PIX</option>
                                    <option value="CREDIT_CARD">Cartão de Crédito</option>
                                    <option value="BOLETO">Boleto</option>
                                    <option value="BILLS">Dinheiro</option>
                                    <option value="OTHER">Outro</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <label className="text-xs font-bold text-gray-600">Observações (Opcional)</label>
                            <textarea rows={2} className="input-primary w-full mt-1" placeholder="Ex: Cliente vai passar para retirar" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
                        </div>
                    </div>

                    <div className="flex gap-3 pt-4 sticky bottom-0 bg-white pb-2">
                        <button type="button" onClick={onClose} className="btn-secondary py-3 flex-1 font-bold">Cancelar</button>
                        <button disabled={loading || selectedItems.length === 0} className="btn-primary py-3 flex-1 font-bold filter drop-shadow-md">
                            {loading ? 'Processando...' : 'Confirmar Pedido'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};


// 2. Pedidos (AGORA COM PAGINAÇÃO E FILTROS)
const OrdersTab = ({ tenantId, onOpenOrderDetails }: { tenantId: string, onOpenOrderDetails: (o: any) => void }) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [orders, setOrders] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [dispatchModalOpen, setDispatchModalOpen] = useState(false);
    const [manualOrderModalOpen, setManualOrderModalOpen] = useState(false);
    const [orderToDispatch, setOrderToDispatch] = useState<any>(null);

    // Estados de Paginação e Filtro
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationMeta, setPaginationMeta] = useState({ totalItems: 0, totalPages: 1, itemsPerPage: 20 });
    const [statusFilter, setStatusFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    // Debounce da busca
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchTerm]);

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                page: currentPage.toString(),
                limit: '20',
                status: statusFilter,
                search: debouncedSearch
            });
            // USA A NOVA ROTA PAGINADA
            const res = await axios.get(`https://zapshop.app/api/admin/store/${tenantId}/orders?${params.toString()}`);
            setOrders(res.data.data);
            setPaginationMeta(res.data.meta);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchOrders(); }, [tenantId, currentPage, statusFilter, debouncedSearch]);

    const handleStatusChange = async (orderId: string, newStatus: string) => {
        const labels: { [key: string]: string } = { 'SHIPPED': 'ENVIADO', 'DELIVERED': 'ENTREGUE', 'CANCELED': 'CANCELADO', 'PAID': 'PAGO', 'PENDING': 'PENDENTE' };
        if (!(await confirm({
            title: 'Alterar Status',
            message: `Deseja alterar o status deste pedido para "${labels[newStatus] || newStatus}"?`,
            type: 'warning'
        }))) return;

        try {
            await axios.put(`https://zapshop.app/api/orders/${orderId}/status`, { status: newStatus, tenant_id: tenantId });
            showToast('Status atualizado!', 'success');
            fetchOrders(); // Recarrega a lista
        } catch (error) {
            showToast('Erro ao salvar status.', 'error');
        }
    };

    const handleDeleteOrder = async (orderId: string) => {
        if (!(await confirm({
            title: 'Excluir Pedido',
            message: "Tem certeza que deseja apagar este pedido permanentemente? Esta ação não pode ser desfeita.",
            type: 'danger'
        }))) return;

        try {
            await axios.delete(`https://zapshop.app/api/admin/store/${tenantId}/orders/${orderId}`);
            showToast('Pedido removido com sucesso!', 'success');
            // Remove o pedido da lista na tela sem precisar recarregar
            setOrders(prev => prev.filter(o => o.id !== orderId));
        } catch (error) {
            console.error("Erro ao deletar:", error);
            showToast("Erro ao apagar pedido do servidor.", 'error');
        }
    };

    return (
        <Card className="animate-fade-in min-h-[500px] flex flex-col relative">
            {manualOrderModalOpen && (
                <ManualOrderModal
                    tenantId={tenantId}
                    onClose={() => setManualOrderModalOpen(false)}
                    onSuccess={() => {
                        fetchOrders();
                        setManualOrderModalOpen(false);
                    }}
                />
            )}
            <div className="p-4 md:p-6 border-b border-surface-100 bg-surface-50/50 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <h3 className="font-bold text-lg text-surface-900 flex items-center gap-2"><ShoppingBag size={20} /> Histórico</h3>

                <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
                    <button
                        onClick={() => setManualOrderModalOpen(true)}
                        className="btn-primary py-2 px-4 shadow-sm flex items-center gap-2 text-sm w-full md:w-auto justify-center"
                    >
                        <Plus size={16} /> Novo Pedido
                    </button>
                    <div className="relative flex-1 min-w-[140px]">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                        <input
                            placeholder="ID ou Cliente..."
                            className="input-primary text-sm py-2 pl-9 w-full"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <select
                        className="input-primary flex-1 min-w-[140px] text-sm py-2 shrink-0 md:max-w-[160px]"
                        value={statusFilter}
                        onChange={e => { setStatusFilter(e.target.value); setCurrentPage(1); }}
                    >
                        <option value="all">Status: Todos</option>
                        <option value="PENDING">Pendente</option>
                        <option value="PAID">Pago</option>
                        <option value="SHIPPED">Enviado</option>
                        <option value="DELIVERED">Entregue</option>
                        <option value="CANCELED">Cancelado</option>
                    </select>
                </div>
            </div>

            <div className="overflow-x-auto flex-1">
                {loading ? <div className="p-10 text-center text-gray-500">Carregando...</div> : (
                    <table className="w-full text-left">
                        <thead className="hidden md:table-header-group bg-surface-50 text-xs font-bold text-gray-500 uppercase tracking-wider">
                            <tr><th className="p-5">ID / Data</th><th className="p-5">Cliente</th><th className="p-5">Resumo</th><th className="p-5">Total</th><th className="p-5 text-right">Status</th></tr>
                        </thead>
                        <tbody className="divide-y divide-surface-100">
                            {orders.length === 0 ? (
                                <tr><td colSpan={5} className="p-10 text-center text-gray-400">Nenhum pedido encontrado.</td></tr>
                            ) : orders.map((o) => (
                                <tr key={o.id} className="flex flex-col md:table-row hover:bg-surface-50/50 transition p-4 md:p-0 border-b md:border-b-0 relative cursor-pointer group" onClick={() => onOpenOrderDetails(o)}>
                                    <td className="p-0 md:p-5 flex flex-col items-start md:block mb-2 md:pr-5">
                                        <span className="md:hidden text-[10px] font-bold text-gray-400 uppercase">Pedido</span>
                                        <div className="flex items-center gap-2">
                                            <div>
                                                <div className="font-mono text-[10px] text-gray-500">#{o.id.slice(0, 8)}</div>
                                                <div className="text-sm font-medium text-surface-900">{new Date(o.created_at).toLocaleDateString()}</div>
                                            </div>
                                            {o.shipping_type === 'PICKUP' ? (
                                                <div className="p-1.5 bg-orange-50 text-orange-600 rounded-lg border border-orange-100" title="Retirada na Loja"><Store size={14} /></div>
                                            ) : o.shipping_type === 'DELIVERY' ? (
                                                <div className="p-1.5 bg-blue-50 text-blue-600 rounded-lg border border-blue-100" title="Entrega / Delivery"><Truck size={14} /></div>
                                            ) : null}
                                        </div>
                                    </td>
                                    <td className="p-0 md:p-5 mb-3">
                                        <span className="md:hidden text-[10px] font-bold text-gray-500 uppercase block mb-1">Cliente</span>
                                        <div className="font-bold text-sm text-gray-900">{o.customer_name || 'Desconhecido'}</div>
                                        <div className="text-xs text-gray-500">{o.customer_phone}</div>
                                    </td>
                                    <td className="hidden md:table-cell p-5">
                                        <div className="text-sm text-gray-600 max-w-xs truncate font-medium">
                                            {o.items && o.items.length > 0 ? (
                                                <>
                                                    <span className="text-surface-900">{o.items[0].name}</span>
                                                    {o.items.length > 1 && <span className="text-brand-600 font-bold ml-1">+ {o.items.length - 1} itens</span>}
                                                </>
                                            ) : 'Itens diversos'}
                                        </div>
                                    </td>
                                    <td className="p-0 md:p-5 mb-4">
                                        <span className="md:hidden text-[10px] font-bold text-gray-400 uppercase block mb-1">Total</span>
                                        <div className="font-bold text-brand-600 text-lg md:text-base">R$ {Number(o.total_amount).toFixed(2)}</div>
                                    </td>
                                    <td className="p-0 md:p-5 md:text-right flex items-center md:justify-end gap-2 absolute top-4 right-4 md:relative md:top-0 md:right-0">
                                        {(o.status === 'PAID' || o.status === 'SHIPPED') && (
                                            <button
                                                className={`p-2 rounded-lg transition ${o.status === 'SHIPPED' ? 'bg-blue-100 text-blue-600 hover:bg-blue-200' : 'bg-orange-100 text-orange-600 hover:bg-orange-200'}`}
                                                onClick={() => { setOrderToDispatch(o); setDispatchModalOpen(true); }}
                                                title={o.status === 'SHIPPED' ? 'Ver Etiqueta / Rastreio' : 'Despachar Pedido'}
                                            >
                                                {o.status === 'SHIPPED' ? <FileText size={18} /> : <Bike size={18} />}
                                            </button>
                                        )}
                                        <div className="relative inline-block">
                                            <select
                                                value={o.status}
                                                onChange={(e) => handleStatusChange(o.id, e.target.value)}
                                                className={`appearance-none pl-3 pr-8 py-1 rounded-full text-xs font-bold border-0 cursor-pointer transition focus:ring-2 focus:ring-offset-1 outline-none ${o.status === 'PAID' ? 'bg-emerald-100 text-emerald-700' : ''} ${o.status === 'PENDING' ? 'bg-amber-100 text-amber-700' : ''} ${o.status === 'SHIPPED' ? 'bg-blue-100 text-blue-700' : ''} ${o.status === 'DELIVERED' ? 'bg-gray-100 text-gray-700' : ''} ${o.status === 'CANCELED' ? 'bg-red-50 text-red-400' : ''}`}
                                            >
                                                <option value="PENDING">Pendente</option>
                                                <option value="PAID">Pago</option>
                                                <option value="SHIPPED">Enviado</option>
                                                <option value="DELIVERED">Entregue</option>
                                                <option value="CANCELED">Cancelado</option>
                                            </select>
                                        </div>
                                        <button
                                            onClick={() => handleDeleteOrder(o.id)}
                                            className="p-2 bg-red-50 text-red-500 rounded-lg hover:bg-red-100 transition flex-shrink-0"
                                            title="Excluir Pedido"
                                        >
                                            <Trash2 size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* COMPONENTE DE PAGINAÇÃO */}
            <div className="p-4 border-t border-gray-100">
                <Pagination
                    currentPage={currentPage}
                    totalPages={paginationMeta.totalPages}
                    onPageChange={setCurrentPage}
                    totalItems={paginationMeta.totalItems}
                    itemsPerPage={paginationMeta.itemsPerPage}
                />
            </div>

            {dispatchModalOpen && <DispatchModal isOpen={dispatchModalOpen} onClose={() => setDispatchModalOpen(false)} order={orderToDispatch} tenantId={tenantId} onSuccess={() => { setDispatchModalOpen(false); fetchOrders(); }} />}
        </Card>
    );
};

// 3. Relatórios
const ReportsTab = ({ tenantId }: { tenantId: string }) => {
    const [dates, setDates] = useState({ start: '', end: '' });
    const [chartData, setChartData] = useState([]);
    const [summary, setSummary] = useState({ revenue: 0, orders_count: 0, ticket_avg: 0, peak_hour: null });
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            let query = `?a=1`;
            if (dates.start && dates.end) query += `&start_date=${dates.start}&end_date=${dates.end}`;
            const [salesRes, summRes] = await Promise.all([
                axios.get(`https://zapshop.app/api/reports/sales/${tenantId}${query}`),
                axios.get(`https://zapshop.app/api/reports/summary/${tenantId}${query}`)
            ]);
            setChartData(salesRes.data); setSummary(summRes.data);
        } catch (e) { console.error(e); } finally { setLoading(false); }
    };

    useEffect(() => { fetchData(); }, [tenantId]);

    const downloadCsv = () => {
        let csv = "RELATORIO GERAL - ZAPSHOP\n\nRESUMO EXECUTIVO\n";
        csv += `Faturamento Total,R$ ${Number(summary.revenue).toFixed(2)}\n`;
        csv += `Total de Pedidos,${summary.orders_count}\n`;
        csv += `Ticket Medio,R$ ${Number(summary.ticket_avg).toFixed(2)}\n`;
        csv += `Horario de Pico,${summary.peak_hour || '-'}h\n\n`;
        csv += "VENDAS POR PERIODO\nData,Qtd Pedidos,Faturamento\n";
        chartData.forEach((d: any) => csv += `${d.date},${d.count},${d.total}\n`);
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = `relatorio_${new Date().toISOString().slice(0, 10)}.csv`; a.click();
    };

    return (
        <div className="space-y-6 animate-fade-in">
            <Card className="p-4 flex flex-wrap items-end justify-between gap-4">
                <div className="flex gap-4 items-end flex-wrap">
                    <div><label className="text-xs font-bold text-gray-500 uppercase block mb-1">Início</label><input type="date" className="input-primary py-1.5" value={dates.start} onChange={e => setDates({ ...dates, start: e.target.value })} /></div>
                    <div><label className="text-xs font-bold text-gray-500 uppercase block mb-1">Fim</label><input type="date" className="input-primary py-1.5" value={dates.end} onChange={e => setDates({ ...dates, end: e.target.value })} /></div>
                    <button onClick={fetchData} className="btn-primary py-2 px-4"><Filter size={16} /> Filtrar</button>
                </div>
                <button onClick={downloadCsv} className="btn-secondary py-2 px-4 text-emerald-600 border-emerald-200 hover:bg-emerald-50">Baixar Relatório CSV</button>
            </Card>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <Card className="p-4"><p className="text-xs text-gray-500 uppercase font-bold mb-1">Receita</p><h3 className="text-xl font-bold text-surface-900">R$ {Number(summary.revenue).toFixed(2)}</h3></Card>
                <Card className="p-4"><p className="text-xs text-gray-500 uppercase font-bold mb-1">Pedidos</p><h3 className="text-xl font-bold text-brand-600">{summary.orders_count}</h3></Card>
                <Card className="p-4"><p className="text-xs text-gray-500 uppercase font-bold mb-1">Ticket Médio</p><h3 className="text-xl font-bold text-emerald-600">R$ {Number(summary.ticket_avg).toFixed(2)}</h3></Card>
                <Card className="p-4"><p className="text-xs text-gray-500 uppercase font-bold mb-1">Pico</p><h3 className="text-xl font-bold text-orange-600">{summary.peak_hour !== null ? `${summary.peak_hour}h` : '--'}</h3></Card>
            </div>
            <SalesChart data={chartData} />
        </div>
    );
};

// 4.5 Cupons
const CouponsTab = ({ tenantId }: any) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [coupons, setCoupons] = useState<any[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [editingCoupon, setEditingCoupon] = useState<any>(null);

    const loadCoupons = async () => { try { const res = await axios.get(`https://zapshop.app/api/coupons/${tenantId}`); setCoupons(res.data); } catch (e) { console.error(e); } };
    useEffect(() => { loadCoupons(); }, [tenantId]);

    const handleDelete = async (id: string) => {
        if (await confirm({
            title: 'Deletar Cupom',
            message: 'Tem certeza que deseja deletar este cupom?',
            type: 'danger'
        })) {
            await axios.delete(`https://zapshop.app/api/coupons/${id}`);
            showToast('Cupom excluído!', 'success');
            loadCoupons();
        }
    };
    
    const handleEdit = (coupon: any) => {
        setEditingCoupon(coupon);
        setShowModal(true);
    };

    return (
        <Card className="flex flex-col min-h-[500px] animate-fade-in">
            {showModal && <CouponModal tenantId={tenantId} onClose={() => { setShowModal(false); setEditingCoupon(null); }} onSuccess={loadCoupons} initialData={editingCoupon} />}
            <div className="p-4 md:p-6 border-b border-surface-100 flex flex-col sm:flex-row justify-between items-center gap-4 bg-surface-50/30">
                <h3 className="font-bold text-lg text-surface-900 flex items-center gap-2"><TicketPercent size={20} /> Cupons de Desconto</h3>
                <button onClick={() => { setEditingCoupon(null); setShowModal(true); }} className="w-full sm:w-auto btn-primary flex items-center justify-center gap-2 shadow-lg shadow-brand-500/20 active:scale-95 transition-all">
                    <Plus size={18} /> Novo Cupom
                </button>
            </div>

            <div className="flex-1">
                {/* VIEW DESKTOP: Tabela visível apenas em telas médias/grandes */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-surface-50 text-xs font-bold text-gray-500 uppercase tracking-wider">
                            <tr><th className="p-5">Código</th><th className="p-5">Desconto</th><th className="p-5">Regras</th><th className="p-5">Usos</th><th className="p-5 text-right">Ações</th></tr>
                        </thead>
                        <tbody className="divide-y divide-surface-100">
                            {coupons.length === 0 ? <tr><td colSpan={5} className="p-10 text-center text-gray-400">Nenhum cupom criado.</td></tr> : coupons.map(c => (
                                <tr key={c.id} className="hover:bg-surface-50/50 transition">
                                    <td className="p-5"><span className="font-mono font-bold text-brand-700 bg-brand-50 px-2 py-1 rounded border border-brand-100">{c.code}</span></td>
                                    <td className="p-5 font-bold">{c.discount_type === 'PERCENTAGE' ? `${c.discount_value}% OFF` : `R$ ${c.discount_value} OFF`}</td>
                                    <td className="p-5 text-sm text-gray-600"><div className="flex flex-col"><span>Mínimo: R$ {Number(c.min_purchase).toFixed(2)}</span>{c.expires_at && <span className="text-xs text-gray-400">Expira: {new Date(c.expires_at).toLocaleDateString()}</span>}</div></td>
                                    <td className="p-5"><Badge color="gray">{c.used_count} / {c.usage_limit || '∞'}</Badge></td>
                                    <td className="p-5 text-right flex justify-end gap-2">
                                        <button onClick={() => handleEdit(c)} className="p-2 text-brand-500 hover:bg-brand-50 rounded"><Edit2 size={18} /></button>
                                        <button onClick={() => handleDelete(c.id)} className="p-2 text-red-400 hover:bg-red-50 rounded"><Trash2 size={18} /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* VIEW MOBILE: Cards visíveis apenas em telas pequenas */}
                <div className="md:hidden divide-y divide-gray-100">
                    {coupons.length === 0 ? (
                        <div className="p-10 text-center text-gray-400 text-sm">Nenhum cupom criado.</div>
                    ) : coupons.map(c => (
                        <div key={c.id} className="p-4 space-y-3 active:bg-gray-50 transition">
                            <div className="flex justify-between items-start">
                                <div className="flex flex-col gap-1">
                                    <span className="text-xs font-bold text-gray-400 uppercase tracking-tighter">Código do Cupom</span>
                                    <span className="font-mono font-black text-brand-700 bg-brand-50 px-3 py-1 rounded-lg border border-brand-100 text-sm inline-block w-fit">
                                        {c.code}
                                    </span>
                                </div>
                                <div className="flex gap-2">
                                    <button onClick={() => handleEdit(c)} className="p-2.5 bg-brand-50 text-brand-500 rounded-xl border border-brand-100">
                                        <Edit2 size={18} />
                                    </button>
                                    <button onClick={() => handleDelete(c.id)} className="p-2.5 bg-red-50 text-red-500 rounded-xl border border-red-100">
                                        <Trash2 size={18} />
                                    </button>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-2">
                                <div className="bg-surface-50 p-3 rounded-xl border border-surface-100">
                                    <span className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Desconto</span>
                                    <span className="block font-black text-surface-900 text-sm">
                                        {c.discount_type === 'PERCENTAGE' ? `${c.discount_value}% OFF` : `R$ ${c.discount_value} OFF`}
                                    </span>
                                </div>
                                <div className="bg-surface-50 p-3 rounded-xl border border-surface-100">
                                    <span className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Usos</span>
                                    <div className="mt-1">
                                        <Badge color="gray">{c.used_count} / {c.usage_limit || '∞'}</Badge>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-brand-50/30 p-3 rounded-xl border border-brand-100/50 flex flex-col gap-1">
                                <div className="flex justify-between items-center text-[11px]">
                                    <span className="font-bold text-brand-700">Compra Mínima:</span>
                                    <span className="font-mono font-bold text-brand-800">R$ {Number(c.min_purchase).toFixed(2)}</span>
                                </div>
                                {c.expires_at && (
                                    <div className="flex justify-between items-center text-[11px] pt-1 border-t border-brand-100/30">
                                        <span className="font-bold text-gray-500">Validade:</span>
                                        <span className="font-medium text-gray-600">{new Date(c.expires_at).toLocaleDateString()}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </Card>
    );
};

// 4.5.1 Modal de Detalhes do Cliente
const CustomerDetailsModal = ({ customerId, onClose }: any) => {
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDetails = async () => { try { const res = await axios.get(`https://zapshop.app/api/customers/${customerId}/details`); setData(res.data); } catch (e) { console.error(e); } finally { setLoading(false); } };
        fetchDetails();
    }, [customerId]);

    if (!customerId) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[80vh]">
                <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
                    <h3 className="text-lg font-bold text-gray-900">Histórico do Cliente</h3>
                    <button onClick={onClose}><X size={20} className="text-gray-500 hover:text-red-500" /></button>
                </div>
                {loading ? <div className="p-10 text-center text-gray-400">Carregando...</div> : data ? (
                    <div className="p-6 overflow-y-auto space-y-6">
                        <div className="flex items-center gap-4 border-b border-gray-100 pb-4">
                            <div className="w-12 h-12 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center font-bold text-xl">{data.client.name?.charAt(0)}</div>
                            <div><h2 className="text-lg font-bold text-gray-900">{data.client.name}</h2><p className="text-sm text-gray-500">{data.client.phone}</p><Badge color={data.client.status === 'CLIENT' ? 'green' : 'gray'}>{data.client.status === 'CLIENT' ? 'COMPRADOR' : 'INTERESSADO'}</Badge></div>
                        </div>
                        <div>
                            <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><ShoppingBag size={18} /> Pedidos Realizados ({data.orders.length})</h4>
                            {data.orders.length === 0 ? <div className="p-4 bg-gray-50 rounded text-center text-sm text-gray-500">Nenhuma compra registrada.</div> :
                                <div className="space-y-2">{data.orders.map((o: any) => (<div key={o.id} className="p-3 border rounded flex justify-between items-center hover:bg-gray-50"><div><div className="font-bold text-gray-800">#{o.id.slice(0, 8)}</div><div className="text-xs text-gray-500">{new Date(o.created_at).toLocaleDateString()}</div ></div><div className="text-right"><div className="font-bold text-brand-600">R$ {Number(o.total_amount).toFixed(2)}</div><Badge color={o.status === 'PAID' ? 'green' : 'orange'}>{o.status}</Badge></div></div>))}</div>
                            }
                        </div>
                    </div>
                ) : <div className="p-10 text-center">Erro ao carregar.</div>}
            </div>
        </div>
    );
};

// 4.5.2 Modal de Novo/Editar Cliente
// 4.5.2 Modal de Novo/Editar Cliente
const CustomerFormModal = ({ tenantId, initialData, onClose, onSuccess }: any) => {
    const { showToast } = useToast();
    const [form, setForm] = useState({
        name: '', phone: '', email: '', cpf: '', status: 'LEAD',
        zip_code: '', street: '', number: '', complement: '', neighborhood: '', city: '', state: ''
    });
    const [loading, setLoading] = useState(false);
    const [calculatingZip, setCalculatingZip] = useState(false);

    useEffect(() => {
        if (initialData) {
            setForm({
                name: initialData.name || '', phone: initialData.phone || '', email: initialData.email || '',
                cpf: initialData.cpf || '', status: initialData.status || 'LEAD',
                zip_code: initialData.address_zip_code || '', street: initialData.address_street || '',
                number: initialData.address_number || '', complement: initialData.address_complement || '',
                neighborhood: initialData.address_neighborhood || '', city: initialData.address_city || '', state: initialData.address_state || ''
            });
        }
    }, [initialData]);

    const handleCepChange = async (e: any) => {
        let v = e.target.value.replace(/\D/g, '');
        if (v.length > 8) v = v.slice(0, 8);
        const maskedV = v.replace(/(\d{5})(\d)/, '$1-$2');
        setForm(prev => ({ ...prev, zip_code: maskedV }));

        if (v.length === 8) {
            setCalculatingZip(true);
            try {
                const res = await fetch(`https://viacep.com.br/ws/${v}/json/`);
                const data = await res.json();
                if (!data.erro) {
                    setForm(prev => ({
                        ...prev, zip_code: maskedV, street: data.logradouro, neighborhood: data.bairro, city: data.localidade, state: data.uf
                    }));
                }
            } catch { } finally { setCalculatingZip(false); }
        }
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault(); setLoading(true);
        try {
            if (initialData) {
                await axios.put(`https://zapshop.app/api/admin/store/${tenantId}/customers/${initialData.id}`, form);
            } else {
                await axios.post(`https://zapshop.app/api/admin/store/${tenantId}/customers`, form);
            }
            showToast('Cliente salvo com sucesso!', 'success');
            onSuccess(); onClose();
        } catch (e: any) {
            showToast(e.response?.data?.error || 'Erro ao salvar cliente', 'error');
        } finally { setLoading(false); }
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl p-6 animate-fade-in max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center mb-6 shrink-0">
                    <h3 className="font-bold text-lg text-surface-900 flex items-center gap-2">
                        <Users size={20} className="text-brand-600" /> {initialData ? 'Editar Cliente' : 'Novo Cliente'}
                    </h3>
                    <button onClick={onClose}><X size={20} className="text-gray-400 hover:text-red-500 transition" /></button>
                </div>
                <form onSubmit={handleSubmit} className="flex flex-col flex-1 overflow-hidden">
                    <div className="overflow-y-auto pr-2 space-y-6 flex-1 custom-scrollbar">
                        {/* DADOS PESSOAIS */}
                        <div className="space-y-4">
                            <h4 className="font-bold text-gray-800 border-b pb-2">Dados Pessoais</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">NOME COMPLETO</label><input required className="input-primary w-full py-2" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Ex: João da Silva" /></div>
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">WHATSAPP (COM DDD)</label><input required className="input-primary w-full py-2" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Ex: 5511999999999" /></div>
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">EMAIL</label><input type="email" className="input-primary w-full py-2" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="opcional@email.com" /></div>
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">CPF</label><input className="input-primary w-full py-2" value={form.cpf} onChange={e => setForm({ ...form, cpf: e.target.value })} placeholder="Opcional" /></div>
                                <div className="md:col-span-2"><label className="block text-xs font-bold text-gray-500 mb-1">STATUS</label><select className="input-primary w-full py-2" value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}><option value="LEAD">INTERESSADO (Lead)</option><option value="CLIENT">COMPRADOR (Cliente)</option></select></div>
                            </div>
                        </div>

                        {/* ENDEREÇO */}
                        <div className="space-y-4">
                            <h4 className="font-bold text-gray-800 border-b pb-2 flex items-center gap-2"><MapPin size={18} className="text-orange-500" /> Endereço (Opcional)</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">CEP</label>
                                    <div className="relative">
                                        <input className="input-primary w-full py-2" placeholder="00000-000" value={form.zip_code} onChange={handleCepChange} maxLength={9} />
                                        {calculatingZip && <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>}
                                    </div>
                                </div>
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">NÚMERO</label><input className="input-primary w-full py-2" value={form.number} onChange={e => setForm({ ...form, number: e.target.value })} /></div>
                            </div>
                            <div><label className="block text-xs font-bold text-gray-500 mb-1">ENDEREÇO (RUA/AV)</label><input className="input-primary w-full py-2" value={form.street} onChange={e => setForm({ ...form, street: e.target.value })} /></div>
                            <div><label className="block text-xs font-bold text-gray-500 mb-1">COMPLEMENTO</label><input className="input-primary w-full py-2" value={form.complement} onChange={e => setForm({ ...form, complement: e.target.value })} placeholder="Apto, Bloco, Casa 2..." /></div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">BAIRRO</label><input className="input-primary w-full py-2" value={form.neighborhood} onChange={e => setForm({ ...form, neighborhood: e.target.value })} /></div>
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">CIDADE</label><input className="input-primary w-full py-2" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} /></div>
                                <div><label className="block text-xs font-bold text-gray-500 mb-1">UF</label><input className="input-primary w-full py-2 uppercase" value={form.state} onChange={e => setForm({ ...form, state: e.target.value })} maxLength={2} /></div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end gap-3 pt-6 mt-4 border-t border-gray-100 shrink-0">
                        <button type="button" onClick={onClose} className="btn-secondary py-2 px-4">Cancelar</button>
                        <button disabled={loading} className="btn-primary py-2 px-4 flex items-center gap-2">
                            {loading ? 'Salvando...' : <><Save size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

// 4.6 Clientes (CRM) - AGORA COM PAGINAÇÃO
const CustomersTab = ({ tenantId }: any) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [activeSubTab, setActiveSubTab] = useState<'list' | 'campaigns'>('list');
    const [customers, setCustomers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [selectedCustomer, setSelectedCustomer] = useState<string | null>(null);
    const [showCampaignModal, setShowCampaignModal] = useState(false);
    const [campaignToEdit, setCampaignToEdit] = useState<any>(null);
    const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
    const [customerToEdit, setCustomerToEdit] = useState<any>(null);

    // Estados de Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationMeta, setPaginationMeta] = useState({ totalItems: 0, totalPages: 1, itemsPerPage: 50 });
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    // Bulk Actions
    const [tagsDef, setTagsDef] = useState<any[]>([]);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);

    // Debounce da busca
    useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedSearch(search);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(t);
    }, [search]);

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                page: currentPage.toString(),
                limit: '50',
                search: debouncedSearch
            });

            // Chama APIs em paralelo
            const [custRes, tagsRes] = await Promise.all([
                axios.get(`https://zapshop.app/api/admin/store/${tenantId}/customers?${params.toString()}`),
                axios.get(`https://zapshop.app/api/tags/${tenantId}`)
            ]);

            setCustomers(custRes.data.data);
            setPaginationMeta(custRes.data.meta);
            setTagsDef(tagsRes.data);

        } catch (e) { console.error(e); } finally { setLoading(false); }
    };

    useEffect(() => {
        if (activeSubTab === 'list') fetchCustomers();
    }, [tenantId, currentPage, debouncedSearch, activeSubTab]);

    const handleDeleteCustomer = async (id: string, name: string) => {
        if (!(await confirm({
            title: 'Excluir Cliente',
            message: `Tem certeza que deseja excluir o cliente ${name}?`,
            type: 'danger'
        }))) return;
        try {
            await axios.delete(`https://zapshop.app/api/admin/store/${tenantId}/customers/${id}`);
            showToast('Cliente excluído!', 'success');
            fetchCustomers();
        } catch (err) {
            console.error("Erro ao excluir cliente:", err);
            showToast("Erro ao excluir cliente.", 'error');
        }
    };

    const handleToggleChatMode = async (id: string, currentMode: string) => {
        const newMode = currentMode === 'BOT' ? 'HUMAN' : 'BOT';
        try {
            await axios.put(`https://zapshop.app/api/admin/store/${tenantId}/customers/${id}/chat-mode`, { mode: newMode });
            showToast(`Modo alterado para ${newMode === 'BOT' ? 'IA' : 'Humano'}`, 'info');
            fetchCustomers();
        } catch (err) {
            console.error("Erro ao alterar modo da IA:", err);
            showToast("Erro ao alterar modo da IA.", 'error');
        }
    };

    const toggleSelectAll = () => {
        if (selectedIds.length === customers.length) setSelectedIds([]);
        else setSelectedIds(customers.map(c => c.id));
    };

    const toggleSelectOne = (id: string) => {
        if (selectedIds.includes(id)) setSelectedIds(selectedIds.filter(i => i !== id));
        else setSelectedIds([...selectedIds, id]);
    };

    const handleBulkTag = async (tagName: string) => {
        if (selectedIds.length === 0) return;
        setBulkActionLoading(true);
        try {
            await axios.post('https://zapshop.app/api/customers/bulk/tags', {
                tenant_id: tenantId,
                customer_ids: selectedIds,
                tag_name: tagName,
                action: 'ADD'
            });
            showToast(`${selectedIds.length} clientes etiquetados com "${tagName}"`, 'success');
            setSelectedIds([]);
            fetchCustomers();
        } catch (e) {
            showToast('Erro ao aplicar etiquetas.', 'error');
        } finally {
            setBulkActionLoading(false);
        }
    };

    const getTagColor = (tagName: string) => {
        const def = tagsDef.find(t => t.name === tagName);
        return def ? def.color : '#9ca3af';
    };

    const handleRemoveTag = async (customerId: string, tagName: string) => {
        if (!(await confirm({
            title: 'Remover Etiqueta',
            message: `Remover a etiqueta "${tagName}" deste cliente?`,
            type: 'warning'
        }))) return;
        try {
            await axios.post('https://zapshop.app/api/customers/bulk/tags', {
                tenant_id: tenantId,
                customer_ids: [customerId],
                tag_name: tagName,
                action: 'REMOVE'
            });
            showToast('Etiqueta removida!', 'info');
            fetchCustomers();
        } catch (e) {
            showToast('Erro ao remover etiqueta.', 'error');
        }
    };

    return (
        <Card className="flex flex-col min-h-[500px] animate-fade-in relative">
            {/* --- ABAS DE NAVEGAÇÃO --- */}
            <div className="flex border-b border-gray-100 bg-white sticky top-0 z-10">
                <button
                    onClick={() => setActiveSubTab('list')}
                    className={`px-6 py-4 text-sm font-bold flex items-center gap-2 transition-all border-b-2 ${activeSubTab === 'list'
                        ? 'border-indigo-600 text-indigo-600 bg-indigo-50/10'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                        }`}
                >
                    <Users size={18} /> Base de Clientes
                </button>
                <button
                    onClick={() => setActiveSubTab('campaigns')}
                    className={`px-6 py-4 text-sm font-bold flex items-center gap-2 transition-all border-b-2 ${activeSubTab === 'campaigns'
                        ? 'border-indigo-600 text-indigo-600 bg-indigo-50/10'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                        }`}
                >
                    <Send size={18} /> Histórico de Campanhas
                </button>
            </div>

            {/* --- CONTEÚDO CONDICIONAL --- */}
            {activeSubTab === 'campaigns' ? (
                <div className="p-6 bg-gray-50/50 flex-1">
                    <CampaignHistory tenantId={tenantId} onEdit={(camp) => { setCampaignToEdit(camp); setActiveSubTab('list'); setShowCampaignModal(true); }} />
                </div>
            ) : (
                <>
                    {selectedCustomer && <CustomerDetailsModal customerId={selectedCustomer} onClose={() => setSelectedCustomer(null)} />}

                    {showTagsModal && <TagsModal isOpen={showTagsModal} onClose={() => { setShowTagsModal(false); fetchCustomers(); }} tenantId={tenantId} />}

                    <div className="p-6 border-b border-surface-100 flex flex-col md:flex-row md:items-center justify-between gap-4 transition-all">
                        {selectedIds.length > 0 ? (
                            <div className="bg-brand-50 w-full p-2 rounded-lg border border-brand-100 flex items-center justify-between animate-fade-in">
                                <div className="flex items-center gap-3 px-2">
                                    <span className="font-bold text-brand-700">{selectedIds.length} selecionados</span>
                                    <div className="h-4 w-px bg-brand-200"></div>
                                    <div className="flex gap-1">
                                        {tagsDef.map(tag => (
                                            <button key={tag.id} onClick={() => handleBulkTag(tag.name)} disabled={bulkActionLoading} className="text-xs px-2 py-1 rounded bg-white border border-brand-200 hover:bg-brand-100 transition flex items-center gap-1" title={`Aplicar etiqueta ${tag.name}`}><div className="w-2 h-2 rounded-full" style={{ background: tag.color }}></div>{tag.name}</button>
                                        ))}
                                    </div>
                                </div>
                                <button onClick={() => setSelectedIds([])} className="text-brand-600 hover:text-brand-800 px-3 py-1 text-sm font-bold">Cancelar</button>
                            </div>
                        ) : (
                            <>
                                {showNewCustomerModal && <CustomerFormModal tenantId={tenantId} initialData={customerToEdit} onClose={() => setShowNewCustomerModal(false)} onSuccess={fetchCustomers} />}
                                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                                    <h3 className="font-bold text-lg text-surface-900 flex items-center gap-2">
                                        <Users size={20} className="text-brand-600" /> Base de Clientes
                                    </h3>
                                    <div className="flex flex-wrap items-center gap-2">
                                        <button onClick={() => { setCustomerToEdit(null); setShowNewCustomerModal(true); }} className="btn-primary text-[10px] py-1.5 px-3 flex items-center gap-1"><Plus size={14} /> Novo</button>
                                        <button onClick={() => setShowTagsModal(true)} className="text-[10px] font-bold text-brand-600 hover:bg-brand-50 px-3 py-1.5 rounded-full border border-brand-100 flex items-center gap-1 transition"><Tag size={14} /> Etiquetas</button>
                                        <button onClick={() => setShowCampaignModal(true)} className="text-[10px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 px-4 py-1.5 rounded-full flex items-center gap-1 transition shadow-md"><Send size={14} /> CAMPANHA</button>
                                    </div>
                                </div>

                                <div className="relative w-full md:w-64">
                                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                                    <input className="input-primary w-full pl-9 py-2 text-sm" placeholder="Buscar nome, telefone..." value={search} onChange={e => setSearch(e.target.value)} />
                                </div>
                            </>
                        )}
                    </div>

                    <div className="flex-1 overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="hidden md:table-header-group bg-surface-50 text-xs font-bold text-gray-500 uppercase tracking-wider">
                                <tr>
                                    <th className="p-5 w-10"><input type="checkbox" className="rounded text-brand-600" checked={customers.length > 0 && selectedIds.length === customers.length} onChange={toggleSelectAll} /></th>
                                    <th className="p-5">Cliente</th>
                                    <th className="p-5">Status & Tags</th>
                                    <th className="p-5">LTV (Gasto)</th>
                                    <th className="p-5">Pedidos</th>
                                    <th className="p-5 text-right">Ações</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-surface-100">
                                {loading ? <tr><td colSpan={6} className="p-10 text-center text-gray-400">Carregando...</td></tr> :
                                    customers.length === 0 ? <tr><td colSpan={6} className="p-10 text-center text-gray-500">Nenhum cliente encontrado.</td></tr> :
                                        customers.map(c => (
                                            <tr key={c.id} className={`flex flex-col md:table-row hover:bg-surface-50 transition p-4 md:p-0 border-b md:border-b-0 relative ${selectedIds.includes(c.id) ? 'bg-brand-50/30' : ''}`}>
                                                {/* Checkbox & Avatar + Nome */}
                                                <td className="p-0 md:p-5 flex items-center gap-3 mb-4 md:mb-0">
                                                    <input type="checkbox" className="rounded text-brand-600" checked={selectedIds.includes(c.id)} onChange={() => toggleSelectOne(c.id)} />
                                                    <div className="flex items-center gap-3">
                                                        <div className="w-10 h-10 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center font-bold text-sm">
                                                            {c.name ? c.name.substring(0, 2).toUpperCase() : 'CL'}
                                                        </div>
                                                        <div>
                                                            <div className="font-bold text-sm text-surface-900">{c.name || 'Sem Nome'}</div>
                                                            <div className="text-[10px] text-gray-500 font-mono">{c.phone}</div>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Status & Tags */}
                                                <td className="p-0 md:p-5 mb-4 md:mb-0">
                                                    <span className="md:hidden text-[10px] font-bold text-gray-400 uppercase block mb-1">Status & Etiquetas</span>
                                                    <div className="flex flex-col gap-2">
                                                        <div>{c.status === 'CLIENT' ? <Badge color="green">COMPRADOR</Badge> : <Badge color="gray">INTERESSADO</Badge>}</div>
                                                        <div className="flex flex-wrap gap-1 mt-1">
                                                            {Array.isArray(c.tags) && c.tags.map((tag: any, idx: number) => {
                                                                const tagName = typeof tag === 'string' ? tag : tag.name;
                                                                const color = getTagColor(tagName);
                                                                return (<span key={idx} className="pl-2 pr-1 py-0.5 rounded-md text-[10px] font-bold text-white shadow-sm flex items-center gap-1 group" style={{ backgroundColor: color }}>{tagName}<button onClick={() => handleRemoveTag(c.id, tagName)} className="hover:bg-black/20 rounded-full p-0.5 transition"><X size={10} /></button></span>)
                                                            })}
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* LTV & Pedidos - Lado a lado no mobile */}
                                                <td className="p-0 md:p-5 mb-4 md:mb-0 flex justify-between md:table-cell">
                                                    <div className="flex-1">
                                                        <span className="md:hidden text-[10px] font-bold text-gray-400 uppercase block mb-1">Total Pago</span>
                                                        <div className="font-bold text-sm text-surface-900">R$ {Number(c.total_spent || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                                                    </div>
                                                    <div className="flex-1 md:hidden text-right">
                                                        <span className="md:hidden text-[10px] font-bold text-gray-400 uppercase block mb-1">Pedidos</span>
                                                        <div className="font-bold text-sm text-gray-600">{c.total_orders}</div>
                                                    </div>
                                                </td>

                                                <td className="hidden md:table-cell p-5 font-bold text-gray-600">{c.total_orders}</td>

                                                {/* Ações */}
                                                <td className="p-0 md:p-5 text-right flex justify-between md:justify-end gap-2 border-t md:border-t-0 pt-3 md:pt-5">
                                                    <span className="md:hidden text-[10px] font-bold text-gray-400 uppercase flex items-center">Ações</span>
                                                    <div className="flex gap-1 items-center">
                                                        <button onClick={() => handleToggleChatMode(c.id, c.chat_mode)} className={`p-2 transition-all rounded-full ${c.chat_mode === 'HUMAN' ? 'text-red-500 bg-red-50 hover:bg-red-100' : 'text-emerald-600 bg-emerald-50 hover:bg-emerald-100'}`} title={c.chat_mode === 'HUMAN' ? 'Conversa Manual (IA Desativada) - Clique para Ativar Robô' : 'IA Ativa (Robô) - Clique para Pausar e Atender Manualmente'}>
                                                            {c.chat_mode === 'HUMAN' ? <BotOff size={18} /> : <Bot size={18} />}
                                                        </button>
                                                        <button onClick={() => setSelectedCustomer(c.id)} className="p-2 text-blue-600" title="Histórico"><ShoppingBag size={18} /></button>
                                                        <button onClick={() => { setCustomerToEdit(c); setShowNewCustomerModal(true); }} className="p-2 text-brand-600" title="Editar"><Edit2 size={18} /></button>
                                                        <button onClick={() => handleDeleteCustomer(c.id, c.name)} className="p-2 text-red-500" title="Excluir"><Trash2 size={18} /></button>
                                                        <a href={`https://wa.me/${c.phone}`} target="_blank" className="p-2 text-green-600" rel="noreferrer" title="WhatsApp"><MessageCircle size={18} /></a>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINAÇÃO DE CLIENTES */}
                    <div className="p-4 border-t border-gray-100">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={paginationMeta.totalPages}
                            onPageChange={setCurrentPage}
                            totalItems={paginationMeta.totalItems}
                            itemsPerPage={paginationMeta.itemsPerPage}
                        />
                    </div>

                    {showCampaignModal && <CampaignModal isOpen={showCampaignModal} onClose={() => { setShowCampaignModal(false); setCampaignToEdit(null); }} tenantId={tenantId} customers={customers} campaignToEdit={campaignToEdit} />}
                </>
            )}
        </Card>
    );
};


const frontendSlugify = (text: string) => {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]/g, '');
};

// 5. Configurações
const SettingsTab = ({ tenantId, initialData, onSuccess }: any) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [formData, setFormData] = useState<any>({
        store_name: '', phone: '', primary_color: '#4f46e5', address: '', email: '', cnpj: '',
        description: '', instagram_url: '', origin_zip_code: '',
        delivery_radius_km: 15, delivery_fee_type: 'FIXED', delivery_fixed_price: 0,
        custom_domain: '', custom_domain_status: 'pending', slug: '',
        allow_delivery_payment: false, disable_automated_payments: false
    });
    const [slugAvailable, setSlugAvailable] = useState<boolean | null>(null);
    const [checkingSlug, setCheckingSlug] = useState(false);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);
    const [showDnsModal, setShowDnsModal] = useState(false);

    const checkSlugAvailability = async (slug: string) => {
        if (!slug || slug === initialData.slug) {
            setSlugAvailable(null);
            return;
        }
        setCheckingSlug(true);
        try {
            const res = await axios.get(`${API_BASE_URL}/admin/check-slug/${slug}`);
            setSlugAvailable(res.data.available);
        } catch (error) {
            console.error('Erro ao verificar slug', error);
        } finally {
            setCheckingSlug(false);
        }
    };

    useEffect(() => {
        if (initialData) {
            setFormData({
                store_name: initialData.name || '',
                phone: initialData.phone || '',
                primary_color: initialData.config_json?.primary_color || '#4f46e5',
                address: initialData.config_json?.address || '',
                email: initialData.config_json?.email || '',
                cnpj: initialData.config_json?.cnpj || '',
                description: initialData.config_json?.description || '',
                instagram_url: initialData.config_json?.instagram_url || '',
                slug: initialData.slug || '',
                origin_zip_code: initialData.origin_zip_code || initialData.config_json?.origin_zip_code || '',
                delivery_radius_km: initialData.delivery_radius_km || 15,
                delivery_fee_type: initialData.delivery_fee_type || 'FIXED',
                delivery_fixed_price: initialData.delivery_fixed_price || 0,
                custom_domain: initialData.custom_domain || '',
                custom_domain_status: initialData.custom_domain_status || 'pending',
                allow_delivery_payment: initialData.config_json?.allow_delivery_payment || false,
                disable_automated_payments: initialData.config_json?.disable_automated_payments || false
            });
        }
    }, [initialData]);

    // ESTADOS PARA O CROPPER DO LOGO
    const [cropperOpen, setCropperOpen] = useState(false);
    const [imageToCrop, setImageToCrop] = useState<string | null>(null);

    const handleLogoSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImageToCrop(reader.result as string);
                setCropperOpen(true);
            };
            reader.readAsDataURL(file);
            e.target.value = '';
        }
    };

    const handleCropComplete = (croppedFile: File) => {
        setLogoFile(croppedFile);
        setCropperOpen(false);
        setImageToCrop(null);
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault(); setLoading(true);
        try {
            const data = new FormData();
            data.append('tenant_id', tenantId);
            Object.keys(formData).forEach(key => data.append(key, (formData as any)[key]));
            if (logoFile) data.append('logo', logoFile);
            await updateStoreSettings(data);
            showToast('Configurações salvas com sucesso!', 'success');
            onSuccess();
        } catch {
            showToast('Erro ao salvar configurações.', 'error');
        } finally { setLoading(false); }
    };

    return (
        <Card className="max-w-2xl p-8 animate-fade-in relative">
            <h3 className="text-xl font-bold text-gray-900 mb-6 border-b border-gray-100 pb-4">Identidade e Configurações</h3>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="flex gap-6 items-start">
                    <div className="flex flex-col gap-2">
                        <div className="w-24 h-24 bg-gray-50 border border-dashed border-gray-300 rounded-xl flex items-center justify-center overflow-hidden relative group cursor-pointer">
                            {logoFile ? <img src={URL.createObjectURL(logoFile)} className="w-full h-full object-cover" /> : initialData?.config_json?.logo_url ? <img src={`/api${initialData.config_json.logo_url}`} className="w-full h-full object-cover" /> : <span className="text-xs text-gray-400">Logo</span>}
                            <input type="file" accept="image/*" className="absolute inset-0 opacity-0 cursor-pointer" onChange={handleLogoSelect} />
                        </div>
                        <span className="text-[10px] text-gray-400 font-bold uppercase text-center">Sugerido: 1:1</span>
                    </div>
                    <div className="flex-1 space-y-4">
                        <div><label className="block text-sm font-bold text-gray-600 mb-1">Nome da Loja</label><input className="input-primary w-full p-2 border rounded" value={formData.store_name} onChange={e => setFormData({ ...formData, store_name: e.target.value })} /></div>
                        <div>
                            <label className="block text-sm font-bold text-gray-600 mb-1">Link Amigável (URL)</label>
                            <div className="flex items-center gap-2">
                                <span className="text-gray-400 text-[10px] md:text-xs font-mono">zapshop.app/store/</span>
                                <div className="relative flex-1">
                                    <input
                                        className={`input-primary w-full p-2 border rounded font-mono text-sm ${slugAvailable === false ? 'border-red-500' : ''}`}
                                        value={formData.slug}
                                        onChange={async (e) => {
                                            const newSlug = frontendSlugify(e.target.value);
                                            if (initialData.slug && initialData.whatsapp_status === 'open' && newSlug !== initialData.slug) {
                                                if (!(await confirm({
                                                    title: 'Alterar Endereço',
                                                    message: "Alterar o slug pode desconectar seu WhatsApp atual. Deseja continuar?",
                                                    type: 'warning'
                                                }))) {
                                                    return;
                                                }
                                            }
                                            setFormData({ ...formData, slug: newSlug });
                                            checkSlugAvailability(newSlug);
                                        }}
                                        placeholder="minha-loja"
                                    />
                                    <div className="absolute right-2 top-1/2 -translate-y-1/2">
                                        {checkingSlug ? (
                                            <div className="w-3 h-3 border-2 border-brand-500/30 border-t-brand-500 rounded-full animate-spin" />
                                        ) : slugAvailable === true ? (
                                            <CheckCircle size={12} className="text-emerald-500" />
                                        ) : slugAvailable === false ? (
                                            <XCircle size={12} className="text-red-500" />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            {slugAvailable === false && <p className="text-[10px] text-red-500 font-bold mt-1">Este endereço já está em uso por outra loja</p>}
                        </div>
                        <div><label className="block text-sm font-bold text-gray-600 mb-1">Cor Principal</label><div className="flex items-center gap-2"><input type="color" className="h-9 w-16 rounded cursor-pointer border-0" value={formData.primary_color} onChange={e => setFormData({ ...formData, primary_color: e.target.value })} /> <span className="text-xs font-mono text-gray-500">{formData.primary_color}</span></div></div>
                    </div>
                </div>
                <div className="bg-orange-50 border border-orange-100 p-4 rounded-xl"><h4 className="font-bold text-orange-800 mb-3 flex items-center gap-2"><Truck size={18} /> Logística</h4><div><label className="block text-sm font-bold text-gray-600 mb-1">CEP de Origem (Para cálculo de frete)</label><input className="input-primary w-full p-2 border rounded bg-white" placeholder="00000-000" value={formData.origin_zip_code} onChange={e => setFormData({ ...formData, origin_zip_code: e.target.value })} /><p className="text-xs text-gray-500 mt-1">Necessário para usar a integração com Melhor Envio.</p></div></div>
                <div className="border-t border-gray-100 pt-6 space-y-4">
                    <h4 className="text-sm font-bold text-gray-600">Informações de Rodapé</h4>
                    <div className="grid md:grid-cols-2 gap-4"><div><label className="block text-sm font-bold text-gray-600 mb-1">WhatsApp (Suporte)</label><input className="input-primary w-full p-2 border rounded" value={formData.phone} onChange={e => setFormData({ ...formData, phone: e.target.value })} /></div><div><label className="block text-sm font-bold text-gray-600 mb-1">Email</label><input type="email" className="input-primary w-full p-2 border rounded" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} /></div></div>
                    <div><label className="block text-sm font-bold text-gray-600 mb-1">Endereço</label><input className="input-primary w-full p-2 border rounded" value={formData.address} onChange={e => setFormData({ ...formData, address: e.target.value })} /></div>
                    <div className="grid md:grid-cols-2 gap-4"><div><label className="block text-sm font-bold text-gray-600 mb-1">CNPJ</label><input className="input-primary w-full p-2 border rounded" value={formData.cnpj} onChange={e => setFormData({ ...formData, cnpj: e.target.value })} /></div><div><label className="block text-sm font-bold text-gray-600 mb-1">Instagram</label><input className="input-primary w-full p-2 border rounded" value={formData.instagram_url} onChange={e => setFormData({ ...formData, instagram_url: e.target.value })} /></div></div>
                    <div><label className="block text-sm font-bold text-gray-600 mb-1">Descrição Curta</label><textarea className="input-primary w-full p-2 border rounded" rows={2} value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} /></div>
                </div>
                <div className="bg-white border border-gray-200 p-4 rounded-xl mt-4">
                    <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2"><Bike size={18} /> Configuração de Entrega</h4>
                    <div className="grid md:grid-cols-2 gap-4"><div><label className="block text-sm font-bold text-gray-600 mb-1">Raio de Entrega (Km)</label><input type="number" className="input-primary w-full p-2 border rounded" placeholder="Ex: 15" value={formData.delivery_radius_km || 15} onChange={e => setFormData({ ...formData, delivery_radius_km: parseFloat(e.target.value) })} /><p className="text-xs text-gray-500 mt-1">Distância máxima para aceitar pedidos.</p></div><div><label className="block text-sm font-bold text-gray-600 mb-1">Tipo de Cobrança</label><select value={formData.delivery_fee_type || 'FIXED'} onChange={(e) => setFormData({ ...formData, delivery_fee_type: e.target.value })} className="input-primary w-full p-2 border rounded"><option value="FIXED">Valor Fixo (Pago no Checkout)</option><option value="VARIABLE">A Combinar (Pago na Entrega)</option></select></div></div>
                    {formData.delivery_fee_type === 'FIXED' && (<div className="mt-4"><label className="block text-sm font-bold text-gray-600 mb-1">Valor Fixo da Entrega (R$)</label><input type="text" className="input-primary w-full p-2 border rounded" value={formData.delivery_fixed_price === 0 ? '' : (formData.delivery_fixed_price || '')} onChange={e => { let v = e.target.value.replace(/[^0-9.,]/g, '').replace(',', '.'); setFormData({ ...formData, delivery_fixed_price: v as any }); }} placeholder="Ex: 15.00" /></div>)}
                </div>

                {/* NOVO: CONFIGURAÇÃO DE PAGAMENTO */}
                <div className="bg-blue-50 border border-blue-100 p-6 rounded-2xl space-y-4">
                    <h4 className="font-bold text-blue-800 flex items-center gap-2"><CreditCard size={18} /> Configurações de Pagamento</h4>
                    <div className="space-y-4">
                        <label className="flex items-center gap-3 cursor-pointer group">
                            <div className="relative">
                                <input 
                                    type="checkbox" 
                                    className="sr-only" 
                                    checked={formData.allow_delivery_payment} 
                                    onChange={e => setFormData({ ...formData, allow_delivery_payment: e.target.checked })} 
                                />
                                <div className={`w-10 h-6 rounded-full transition-colors ${formData.allow_delivery_payment ? 'bg-emerald-500' : 'bg-gray-300'}`}></div>
                                <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${formData.allow_delivery_payment ? 'translate-x-4' : ''}`}></div>
                            </div>
                            <div>
                                <span className="text-sm font-bold text-gray-700 block">Aceitar Pagamento na Entrega</span>
                                <span className="text-[10px] text-gray-500">Permite que o cliente finalize o pedido e pague diretamente para você.</span>
                            </div>
                        </label>

                        {formData.allow_delivery_payment && (
                            <label className="flex items-center gap-3 cursor-pointer group animate-fade-in">
                                <div className="relative">
                                    <input 
                                        type="checkbox" 
                                        className="sr-only" 
                                        checked={formData.disable_automated_payments} 
                                        onChange={e => setFormData({ ...formData, disable_automated_payments: e.target.checked })} 
                                    />
                                    <div className={`w-10 h-6 rounded-full transition-colors ${formData.disable_automated_payments ? 'bg-orange-500' : 'bg-gray-300'}`}></div>
                                    <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${formData.disable_automated_payments ? 'translate-x-4' : ''}`}></div>
                                </div>
                                <div>
                                    <span className="text-sm font-bold text-gray-700 block">Operar APENAS com Pagamento na Entrega</span>
                                    <span className="text-[10px] text-gray-500">Desativa Pix e Cartão de Crédito automatizados do Mercado Pago.</span>
                                </div>
                            </label>
                        )}
                    </div>
                </div>
                {/* SEÇÃO: DOMÍNIO PRÓPRIO (WHITELABEL) */}
                <div className={`p-6 rounded-2xl border-2 transition-all ${['INTERMEDIÁRIO', 'PRO'].includes(initialData?.plan_type?.toUpperCase()) ? 'bg-brand-50/30 border-brand-100' : 'bg-gray-50 border-gray-100 opacity-75'}`}>
                    <div className="flex items-center justify-between mb-4">
                        <h4 className="font-black text-brand-900 flex items-center gap-2 uppercase text-xs tracking-widest">
                            <Globe size={18} /> Domínio Próprio
                        </h4>
                        {['INTERMEDIÁRIO', 'PRO'].includes(initialData?.plan_type?.toUpperCase()) ? (
                            <Badge color={formData.custom_domain_status === 'active' ? 'green' : 'yellow'}>
                                {formData.custom_domain_status === 'active' ? 'ATIVO' : 'PENDENTE'}
                            </Badge>
                        ) : (
                            <Badge color="gray">UPGRADE NECESSÁRIO</Badge>
                        )}
                    </div>

                    {['INTERMEDIÁRIO', 'PRO'].includes(initialData?.plan_type?.toUpperCase()) ? (
                        <div className="space-y-4">
                            <p className="text-[10px] text-brand-700 font-medium leading-relaxed">
                                Use seu próprio domínio (ex: www.sualoja.com.br) para profissionalizar sua marca.
                            </p>
                            <div className="flex gap-2">
                                <input
                                    className="input-primary flex-1 py-3 px-4 font-bold text-sm"
                                    placeholder="ex: lojadodiogo.com"
                                    value={formData.custom_domain}
                                    onChange={e => setFormData({ ...formData, custom_domain: e.target.value.toLowerCase().trim() })}
                                />
                                <button
                                    type="button"
                                    onClick={async () => {
                                        if (!formData.custom_domain) return showToast('Insira um domínio', 'error');
                                        setLoading(true);
                                        try {
                                            await axios.put(`https://zapshop.app/api/admin/tenant/${tenantId}/custom-domain`, {
                                                domain: formData.custom_domain
                                            });
                                            showToast('Domínio salvo! Configure o DNS.', 'success');
                                            onSuccess();
                                        } catch (e) {
                                            showToast('Erro ao salvar domínio. Verifique se ele já está em uso.', 'error');
                                        } finally {
                                            setLoading(false);
                                        }
                                    }}
                                    className="btn-primary py-3 px-6 shadow-brand-500/20"
                                >
                                    Salvar
                                </button>
                            </div>

                            {formData.custom_domain && formData.custom_domain_status === 'active' && (
                                <div className="p-3 bg-green-50 border border-green-100 rounded-xl flex items-center justify-between mt-4">
                                    <div className="flex items-center gap-2 text-green-700">
                                        <Check size={16} />
                                        <span className="text-xs font-bold uppercase tracking-wider">URL em uso:</span>
                                        <a href={`https://${formData.custom_domain}`} target="_blank" rel="noreferrer" className="text-xs font-black underline">
                                            {formData.custom_domain}
                                        </a>
                                    </div>
                                    <Globe size={16} className="text-green-200" />
                                </div>
                            )}
                            <button
                                type="button"
                                onClick={() => setShowDnsModal(true)}
                                className="text-[10px] font-black text-brand-600 uppercase tracking-widest flex items-center gap-1 hover:underline"
                            >
                                <HelpCircle size={14} /> Como configurar meu DNS?
                            </button>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-xs text-gray-500 mb-3">O recurso de domínio próprio está disponível apenas nos planos <strong>Intermediário e PRO</strong>.</p>
                            <button type="button" onClick={() => window.location.hash = 'subscription'} className="text-[10px] font-black text-brand-600 uppercase tracking-widest hover:bg-brand-50 px-4 py-2 rounded-lg border border-brand-100 transition-all">Ver Planos de Upgrade</button>
                        </div>
                    )}
                </div>

                <div className="pt-6 border-t border-gray-100"><button disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-black py-4 rounded-2xl shadow-xl shadow-emerald-600/20 transition-all active:scale-95">{loading ? 'Salvando...' : 'Salvar Todas Configurações'}</button></div>
            </form>

            {showDnsModal && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
                    <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden animate-scale-up">
                        <div className="bg-brand-600 p-6 text-white flex justify-between items-center">
                            <h3 className="text-xl font-black">Configuração de DNS</h3>
                            <button onClick={() => setShowDnsModal(false)}><X size={24} /></button>
                        </div>
                        <div className="p-8 space-y-6">
                            <p className="text-sm text-gray-600 leading-relaxed">
                                Para que seu domínio próprio (<strong>{formData.custom_domain || 'seudominio.com'}</strong>) aponte para a vitrine do ZapShop, vá até seu provedor de domínio (Registro.br, GoDaddy, Cloudflare) e crie o seguinte apontamento:
                            </p>
                            <div className="bg-surface-50 p-6 rounded-2xl border-2 border-dashed border-brand-100 space-y-4">
                                <div>
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">Tipo de Registro</span>
                                    <code className="text-brand-600 font-black text-lg">A</code>
                                </div>
                                <div>
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">Nome / Host</span>
                                    <code className="text-gray-900 font-black text-lg">@ <span className="text-gray-400 font-medium text-xs">(ou seu subdomínio)</span></code>
                                </div>
                                <div>
                                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-1">Valor / Destino</span>
                                    <code className="text-brand-600 font-black text-lg">31.97.242.168</code>
                                </div>
                            </div>
                            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100 flex gap-3">
                                <div className="mt-1"><AlertCircle size={18} className="text-amber-600" /></div>
                                <p className="text-[10px] text-amber-800 leading-relaxed font-medium">
                                    <strong>Atenção:</strong> Após salvar, a propagação do DNS pode levar até 24 horas. O certificado SSL será gerado automaticamente assim que o apontamento for detectado.
                                </p>
                            </div>
                            <button onClick={() => setShowDnsModal(false)} className="w-full btn-primary py-4 font-black">Entendido</button>
                        </div>
                    </div>
                </div>
            )}

            {cropperOpen && imageToCrop && (
                <ImageCropperModal
                    image={imageToCrop}
                    onClose={() => { setCropperOpen(false); setImageToCrop(null); }}
                    onCropComplete={handleCropComplete}
                    aspect={1}
                />
            )}
        </Card>
    );
};

// --- MODAL DE CONFIGURAÇÃO DO TENANT (SUPER ADMIN) ---
const TenantConfigModal = ({ tenantId, onClose, onTenantDeleted }: any) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        whatsapp_instance: '', system_prompt: '', trigger_mode: 'ALWAYS_ON',
        trigger_keywords: '', payment_token: '', shipping_token: '',
        store_name: '', phone: '', email: '', is_active: true,
        custom_domain: '', custom_domain_status: 'pending'
    });

    useEffect(() => {
        const loadData = async () => {
            try {
                const res = await axios.get(`https://zapshop.app/api/admin/tenant/${tenantId}`);
                const t = res.data;
                setFormData({
                    store_name: t.name, phone: t.phone, email: t.email, is_active: t.is_active,
                    whatsapp_instance: t.whatsapp_instance_name || '', system_prompt: t.ai_config?.system_prompt || '',
                    trigger_mode: t.ai_config?.trigger_mode || 'ALWAYS_ON', trigger_keywords: t.ai_config?.trigger_keywords || '',
                    payment_token: t.payment_config?.access_token || '', shipping_token: t.shipping_config?.token || '',
                    custom_domain: t.custom_domain || '', custom_domain_status: t.custom_domain_status || 'pending'
                });
            } catch (err) {
                showToast('Erro ao carregar dados da loja.', 'error');
                onClose();
            }
        };
        loadData();
    }, [tenantId]);

    const handleSave = async () => {
        setLoading(true);
        try {
            // Salva as integrações base
            const payload = new FormData();
            payload.append('tenant_id', tenantId); payload.append('whatsapp_instance_name', formData.whatsapp_instance);
            const aiConfig = { system_prompt: formData.system_prompt, trigger_mode: formData.trigger_mode, trigger_keywords: formData.trigger_keywords, model: 'gpt-4o-mini' };
            const payConfig = { provider: 'mercadopago', access_token: formData.payment_token }; const shipConfig = { provider: 'melhor_envio', token: formData.shipping_token };
            payload.append('ai_config', JSON.stringify(aiConfig)); payload.append('payment_config', JSON.stringify(payConfig)); payload.append('shipping_config', JSON.stringify(shipConfig));
            await axios.put('https://zapshop.app/api/settings', payload);

            // Salva os dados administrativos restritos (Status e E-mail)
            await axios.put(`https://zapshop.app/api/admin/tenant/${tenantId}`, {
                email: formData.email,
                is_active: formData.is_active
            });

            showToast('Salvo com sucesso!', 'success'); onClose();
        } catch (error) {
            showToast('Erro ao salvar.', 'error');
        } finally { setLoading(false); }
    };

    const handleDelete = async () => {
        const confirmText = prompt(`Tem certeza que deseja apagar DEFINITIVAMENTE esta loja? Digite "DELETAR" para confirmar:`);
        if (confirmText === 'DELETAR') {
            setLoading(true);
            try {
                await axios.delete(`https://zapshop.app/api/admin/tenants/${tenantId}`);
                showToast('Loja Excluída.', 'success');
                onTenantDeleted();
                onClose();
            } catch (error) {
                showToast('Erro ao excluir loja.', 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="fixed inset-0 bg-surface-900/60 backdrop-blur-sm flex items-center justify-center z-[70] p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[90vh]">
                <div className="px-6 py-4 border-b border-surface-100 flex justify-between items-center bg-surface-50"><div><h3 className="text-lg font-bold text-surface-900">Configurar Loja: {formData.store_name}</h3><p className="text-xs text-gray-500">ID: {tenantId}</p></div><button onClick={onClose}><X size={20} className="text-gray-500" /></button></div>
                <div className="p-6 overflow-y-auto space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-surface-50 p-4 rounded-xl border border-surface-200">
                            <label className="text-xs font-bold text-gray-500 uppercase">E-mail do Lojista</label>
                            <input type="email" className="input-primary mt-1" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                            <p className="text-[10px] text-gray-500 mt-1">Este e-mail é usado para login. Mudá-lo afetará o acesso.</p>
                        </div>
                        <div className={`p-4 rounded-xl border ${formData.is_active ? 'bg-emerald-50 border-emerald-100' : 'bg-red-50 border-red-100'}`}>
                            <label className={`text-xs font-bold uppercase ${formData.is_active ? 'text-emerald-700' : 'text-red-700'}`}>Status da Loja</label>
                            <select className="input-primary mt-1" value={formData.is_active ? 'true' : 'false'} onChange={e => setFormData({ ...formData, is_active: e.target.value === 'true' })}>
                                <option value="true">Ativa (Acesso Liberado)</option>
                                <option value="false">Bloqueada (Inadimplente / Outros)</option>
                            </select>
                        </div>
                    </div>

                    <div className="bg-green-50 p-4 rounded-xl border border-green-100"><h4 className="font-bold text-green-800 flex items-center gap-2 mb-2"><MessageCircle size={18} /> Conexão WhatsApp</h4><label className="text-xs font-bold text-gray-500 uppercase">Nome da Instância (Evolution API)</label><input className="input-primary mt-1" placeholder="Ex: LojaDoJoao" value={formData.whatsapp_instance} onChange={e => setFormData({ ...formData, whatsapp_instance: e.target.value })} /></div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"><div><label className="text-xs font-bold text-gray-500 uppercase">Modo de Disparo</label><select className="input-primary mt-1" value={formData.trigger_mode} onChange={e => setFormData({ ...formData, trigger_mode: e.target.value })}><option value="ALWAYS_ON">Sempre Ativo</option><option value="KEYWORD">Palavra-Chave</option></select></div>{formData.trigger_mode === 'KEYWORD' && (<div><label className="text-xs font-bold text-gray-500 uppercase">Palavras-Chave</label><input className="input-primary mt-1" placeholder="Ex: oi, preço, ajuda" value={formData.trigger_keywords} onChange={e => setFormData({ ...formData, trigger_keywords: e.target.value })} /></div>)}</div>
                    <div className="bg-purple-50 p-4 rounded-xl border border-purple-100"><h4 className="font-bold text-purple-800 flex items-center gap-2 mb-2"><Bot size={18} /> Cérebro da IA</h4><label className="text-xs font-bold text-gray-500 uppercase">System Prompt (Personalidade)</label><textarea rows={4} className="input-primary mt-1" placeholder="Ex: Você é um vendedor especialista em tênis..." value={formData.system_prompt} onChange={e => setFormData({ ...formData, system_prompt: e.target.value })} /></div>
                    <div className="grid grid-cols-2 gap-4"><div className="bg-blue-50 p-4 rounded-xl border border-blue-100"><h4 className="font-bold text-blue-800 flex items-center gap-2 mb-2"><CreditCard size={18} /> Pagamento</h4><label className="text-xs font-bold text-gray-500 uppercase">MercadoPago Token</label><input type="password" className="input-primary mt-1" value={formData.payment_token} placeholder="APP_USR-..." onChange={e => setFormData({ ...formData, payment_token: e.target.value })} /></div><div className="bg-orange-50 p-4 rounded-xl border border-orange-100"><h4 className="font-bold text-orange-800 flex items-center gap-2 mb-2"><Truck size={18} /> Melhor Envio</h4><label className="text-xs font-bold text-gray-500 uppercase">Token de API</label><input type="password" className="input-primary mt-1" placeholder="Token" value={formData.shipping_token} onChange={e => setFormData({ ...formData, shipping_token: e.target.value })} /></div></div>
                </div>
                <div className="p-4 border-t border-surface-100 bg-surface-50 flex justify-between items-center gap-3">
                    <button onClick={handleDelete} className="text-red-500 hover:text-red-700 hover:bg-red-50 px-3 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition" title="Excluir Definitivamente">
                        <Trash2 size={16} /> <span className="hidden sm:inline">Excluir Loja</span>
                    </button>
                    <div className="flex gap-3">
                        <button onClick={onClose} className="btn-secondary">Cancelar</button>
                        <button onClick={handleSave} disabled={loading} className="btn-primary flex items-center gap-2"><Save size={18} /> {loading ? 'Salvando...' : 'Salvar'}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- ABA: TOKEN DE PAGAMENTO (SUPER ADMIN) ---
const PaymentTokenTab = () => {
    const { showToast } = useToast();
    const [settings, setSettings] = useState<any>({ mercadopago_access_token: '' });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get('https://zapshop.app/api/admin/platform-settings');
                setSettings(res.data);
            } catch (error) {
                console.error('Erro ao buscar settings', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    const handleSave = async () => {
        setSaving(true);
        try {
            await axios.put('https://zapshop.app/api/admin/platform-settings', settings);
            showToast('Configurações atualizadas com sucesso!', 'success');
        } catch (error) {
            showToast('Erro ao salvar configurações.', 'error');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="p-4 text-center text-gray-500 animate-pulse">Carregando configurações...</div>;

    return (
        <div className="space-y-6">
            <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block italic">Access Token Mercado Pago</label>
                <input
                    type="password"
                    className="input-primary w-full p-3 font-mono text-sm"
                    value={settings.mercadopago_access_token || ''}
                    onChange={e => setSettings({ ...settings, mercadopago_access_token: e.target.value })}
                    placeholder="APP_USR-..."
                />
                <p className="text-[10px] text-gray-400 mt-2 leading-relaxed">
                    Este token é usado para processar as <strong>assinaturas dos lojistas</strong> (Básico, Intermediário, Pro). Cole aqui o seu Access Token de Produção.
                </p>
            </div>

            <button
                onClick={handleSave}
                disabled={saving}
                className="w-full bg-brand-600 hover:bg-brand-700 text-white font-black py-4 rounded-2xl shadow-xl shadow-brand-600/20 transition-all active:scale-95 flex items-center justify-center gap-2"
            >
                <Save size={18} /> {saving ? 'Salvando...' : 'Salvar Token Global'}
            </button>
        </div>
    );
};


// --- ABA: MENSALIDADE (LOJISTA) ---
const SubscriptionTab = ({ tenantId }: { tenantId: string }) => {
    const [sub, setSub] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSub = async () => {
            try {
                const res = await axios.get(`https://zapshop.app/api/admin/store/${tenantId}/subscription`);
                setSub(res.data);
            } catch (error) {
                console.error('Erro ao buscar mensalidade', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSub();
    }, [tenantId]);

    if (loading) return <div className="p-12 text-center text-gray-400 animate-pulse">Carregando dados da assinatura...</div>;
    if (!sub) return <div className="p-12 text-center text-red-400 font-bold">Erro ao carregar dados.</div>;

    const usagePercent = Math.min(100, (sub.current_products / sub.product_limit) * 100);
    const isOverLimit = sub.current_products >= sub.product_limit;

    const getStatusInfo = (status: string) => {
        switch (status?.toUpperCase()) {
            case 'ACTIVE': return { label: 'ATIVA', color: 'green', icon: CheckCircle };
            case 'PENDING': return { label: 'AGUARDANDO PAGAMENTO', color: 'orange', icon: Clock };
            case 'CANCELLED':
            case 'REJECTED': return { label: 'CANCELADA / EXPIRADA', color: 'red', icon: X };
            default: return { label: 'DESCONHECIDO', color: 'gray', icon: HelpCircle };
        }
    };

    const status = getStatusInfo(sub.subscription_status);

    return (
        <div className="space-y-6 animate-fade-in">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* CARD: PLANO ATUAL */}
                <Card className="p-6">
                    <div className="flex items-center gap-4 mb-4">
                        <div className="p-3 bg-brand-50 rounded-2xl text-brand-600">
                            <Layers size={24} />
                        </div>
                        <div>
                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Plano Atual</p>
                            <h3 className="text-xl font-black text-surface-900">{sub.plan_type}</h3>
                        </div>
                    </div>
                    <div className="pt-4 border-t border-surface-100 mt-2">
                        <p className="text-xs text-gray-500 font-medium">Cadastrado desde {new Date(sub.created_at).toLocaleDateString('pt-BR')}</p>
                    </div>
                </Card>

                {/* CARD: STATUS PAGAMENTO */}
                <Card className="p-6 md:col-span-2">
                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center gap-4">
                            <div className={`p-3 rounded-2xl ${status.color === 'green' ? 'bg-emerald-50 text-emerald-600' : status.color === 'orange' ? 'bg-orange-50 text-orange-600' : 'bg-red-50 text-red-600'}`}>
                                <status.icon size={24} />
                            </div>
                            <div>
                                <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Status da Assinatura</p>
                                <Badge color={status.color}>{status.label}</Badge>
                            </div>
                        </div>
                        {sub.subscription_status !== 'ACTIVE' && (
                            <button
                                onClick={() => window.location.href = `/checkout?tenantId=${tenantId}`}
                                className="btn-primary py-2 px-6 text-sm"
                            >
                                Regularizar Agora
                            </button>
                        )}
                    </div>
                    {sub.subscription_id && (
                        <div className="bg-surface-50 p-3 rounded-xl border border-surface-100 flex justify-between items-center">
                            <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">ID no Mercado Pago</span>
                            <span className="font-mono text-xs text-surface-600">{sub.subscription_id}</span>
                        </div>
                    )}
                </Card>
            </div>

            {/* BARRA DE LIMITE DE PRODUTOS */}
            <Card className="p-8">
                <div className="flex justify-between items-end mb-4">
                    <div>
                        <h3 className="text-lg font-black text-surface-900 flex items-center gap-2">
                            <Package className="text-brand-600" size={20} /> Limite de Catálogo
                        </h3>
                        <p className="text-sm text-gray-500 font-medium">Uso atual de produtos na sua vitrine</p>
                    </div>
                    <div className="text-right">
                        <span className={`text-2xl font-black ${isOverLimit ? 'text-red-500' : 'text-brand-600'}`}>{sub.current_products}</span>
                        <span className="text-gray-400 font-bold"> / {sub.product_limit}</span>
                    </div>
                </div>

                <div className="h-4 bg-surface-100 rounded-full overflow-hidden border border-surface-200">
                    <div
                        className={`h-full transition-all duration-1000 ${isOverLimit ? 'bg-red-500' : usagePercent > 80 ? 'bg-orange-500' : 'bg-brand-500'}`}
                        style={{ width: `${usagePercent}%` }}
                    />
                </div>

                {isOverLimit && (
                    <div className="mt-4 p-4 bg-red-50 border border-red-100 rounded-xl flex items-start gap-3">
                        <X size={18} className="text-red-500 mt-0.5" />
                        <div>
                            <p className="text-sm font-bold text-red-700">Limite de produtos atingido!</p>
                            <p className="text-xs text-red-600">Para cadastrar mais itens e continuar vendendo, faça o upgrade para o plano superior.</p>
                        </div>
                    </div>
                )}
            </Card>

            <div className="text-center p-6 border-2 border-dashed border-surface-200 rounded-3xl">
                <HelpCircle size={32} className="mx-auto text-surface-300 mb-3" />
                <h4 className="font-bold text-surface-900">Dúvidas sobre sua fatura?</h4>
                <p className="text-xs text-gray-400 mb-4 max-w-xs mx-auto">Nossa equipe financeira está disponível via WhatsApp para te ajudar com qualquer questão de pagamento.</p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <a
                        href="https://wa.me/5521991000120?text=sou%20us%C3%A1rio%20do%20zapshop%20e%20preciso%20de%20ajuda%20com%20assuntos%20sobre%20mensalidade"
                        target="_blank"
                        rel="noreferrer"
                        className="btn-secondary py-2 px-6 flex items-center gap-2"
                    >
                        <MessageCircle size={16} /> Falar com Financeiro
                    </a>
                    <a
                        href="https://wa.me/5521991000120?text=sou%20lojista%20no%20zapshop%20e%20quero%20cancelar%20minha%20assinatura"
                        target="_blank"
                        rel="noreferrer"
                        className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-6 rounded-xl flex items-center gap-2 transition-all active:scale-95 shadow-lg shadow-red-500/20"
                    >
                        <XCircle size={16} /> Solicitar Cancelamento
                    </a>
                </div>
            </div>
        </div>
    );
};

// --- ABA: FINANCEIRO (SUPER ADMIN) ---
const FinancialTab = () => {
    const [stats, setStats] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await axios.get('https://zapshop.app/api/admin/financial/subscriptions');
                setStats(res.data);
            } catch (error) {
                console.error('Erro ao buscar dados financeiros', error);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    const getStatusColor = (status: string) => {
        switch (status?.toUpperCase()) {
            case 'ACTIVE': return 'green';
            case 'PENDING': return 'orange';
            case 'CANCELLED':
            case 'REJECTED': return 'red';
            default: return 'gray';
        }
    };

    if (loading) return <div className="p-12 text-center text-gray-500 animate-pulse">Carregando dados financeiros...</div>;

    return (
        <Card className="overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-surface-50 border-b border-surface-100">
                        <tr>
                            <th className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">Lojista</th>
                            <th className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">Plano</th>
                            <th className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">Status</th>
                            <th className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest">ID Assinatura</th>
                            <th className="px-6 py-4 text-[10px] font-black text-gray-400 uppercase tracking-widest text-right">Cadastrado em</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-surface-100">
                        {stats.map((item) => (
                            <tr key={item.id} className="hover:bg-surface-50/50 transition-colors">
                                <td className="px-6 py-4">
                                    <div className="font-bold text-surface-900">{item.store_name}</div>
                                    <div className="text-xs text-gray-400">{item.email}</div>
                                </td>
                                <td className="px-6 py-4">
                                    <span className="text-xs font-bold text-brand-600 bg-brand-50 px-2 py-1 rounded-lg uppercase">{item.plan_type}</span>
                                </td>
                                <td className="px-6 py-4">
                                    <Badge color={getStatusColor(item.subscription_status)}>{item.subscription_status || 'DESCONHECIDO'}</Badge>
                                </td>
                                <td className="px-6 py-4 font-mono text-[10px] text-gray-400">
                                    {item.subscription_id || '-'}
                                </td>
                                <td className="px-6 py-4 text-right text-xs text-gray-400">
                                    {new Date(item.created_at).toLocaleDateString('pt-BR')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
};

// --- SUPER ADMIN ---
const SuperAdminView = ({ user }: any) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [formData, setFormData] = useState({ store_name: '', owner_name: '', email: '', password: '', plan_type: 'BÁSICO', slug: '', phone: '' });
    const [slugAvailable, setSlugAvailable] = useState<boolean | null>(null);
    const [checkingSlug, setCheckingSlug] = useState(false);
    const [tenants, setTenants] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [configTenantId, setConfigTenantId] = useState<string | null>(null);

    const [activeView, setActiveView] = useState('dashboard');
    const [notifications, setNotifications] = useState(0);

    const loadTenants = async () => { try { const res = await axios.get('https://zapshop.app/api/admin/tenants'); setTenants(res.data); } catch (error) { console.error(error); } };

    const fetchNotifications = async () => {
        try {
            const res = await axios.get('https://zapshop.app/api/admin/support/notifications');
            setNotifications(res.data.count);
        } catch (err) {
            console.error('Erro ao buscar notificações:', err);
        }
    };

    useEffect(() => {
        loadTenants();
        fetchNotifications();
        const interval = setInterval(fetchNotifications, 60000);
        return () => clearInterval(interval);
    }, []);

    const checkSlugAvailability = async (slug: string) => {
        if (!slug) {
            setSlugAvailable(null);
            return;
        }
        setCheckingSlug(true);
        try {
            const res = await axios.get(`${API_BASE_URL}/admin/check-slug/${slug}`);
            setSlugAvailable(res.data.available);
        } catch (error) {
            console.error('Erro ao verificar slug', error);
        } finally {
            setCheckingSlug(false);
        }
    };

    const handleCreateTenant = async (e: React.FormEvent) => {
        e.preventDefault();
        if (slugAvailable === false) {
            showToast('Este endereço já está em uso.', 'error');
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/admin/create-tenant`, formData);
            setFormData({ store_name: '', owner_name: '', email: '', password: '', plan_type: 'BÁSICO', slug: '', phone: '' });
            setSlugAvailable(null);
            showToast('Loja criada!', 'success');
            loadTenants();
        } catch (error: any) {
            const errorMsg = error.response?.data?.error || 'Erro ao criar loja.';
            showToast(errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteTenant = async (id: string, name: string) => {
        if (prompt(`Digite "DELETAR" para apagar a loja ${name}`) === 'DELETAR') {
            try {
                await axios.delete(`https://zapshop.app/api/admin/tenants/${id}`);
                showToast('Loja apagada.', 'success');
                loadTenants();
            } catch (e) {
                showToast('Erro ao apagar loja.', 'error');
            }
        }
    };

    return (
        <div className="min-h-screen bg-surface-50 flex flex-col font-sans text-surface-900">
            {configTenantId && <TenantConfigModal tenantId={configTenantId} onClose={() => setConfigTenantId(null)} />}
            <header className="bg-brand-900 text-white p-4 shadow-lg sticky top-0 z-10">
                <div className="max-w-7xl mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-6">
                        <h1 className="text-xl font-bold flex items-center gap-2">
                            <img src="/logozapshopsaas.png" className="h-8 invert brightness-200" /> Painel Mestre
                        </h1>
                        <nav className="hidden md:flex items-center gap-1">
                            <button
                                onClick={() => setActiveView('dashboard')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeView === 'dashboard' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white hover:bg-white/10'}`}
                            >
                                Lojas
                            </button>
                            <button
                                onClick={() => setActiveView('support')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2 ${activeView === 'support' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white hover:bg-white/10'}`}
                            >
                                Suporte
                                {notifications > 0 && <span className="w-2 h-2 bg-amber-400 rounded-full animate-pulse" />}
                            </button>
                            <button
                                onClick={() => setActiveView('payment-token')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2 ${activeView === 'payment-token' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white hover:bg-white/10'}`}
                            >
                                <DollarSign size={14} /> Token de Pagamento
                            </button>
                            <button
                                onClick={() => setActiveView('financial')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2 ${activeView === 'financial' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white hover:bg-white/10'}`}
                            >
                                Financeiro
                            </button>
                            <button
                                onClick={() => setActiveView('connections')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all flex items-center gap-2 ${activeView === 'connections' ? 'bg-white/20 text-white' : 'text-white/60 hover:text-white hover:bg-white/10'}`}
                            >
                                <QrCode size={14} /> Conexões
                            </button>
                        </nav>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="relative cursor-pointer mr-2" onClick={() => setActiveView('support')}>
                            <HelpCircle size={20} className={notifications > 0 ? "text-amber-400 animate-pulse" : "text-white/60"} />
                            {notifications > 0 && (
                                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold flex items-center justify-center rounded-full border border-brand-900">
                                    {notifications}
                                </span>
                            )}
                        </div>
                        <button onClick={() => { localStorage.clear(); window.location.href = '/login'; }} className="bg-white/10 hover:bg-white/20 px-3 py-1 rounded text-sm flex items-center gap-2 transition">
                            <LogOut size={14} /> Sair
                        </button>
                    </div>
                </div>
            </header>

            {activeView === 'support' ? (
                <div className="flex-1 p-4 md:p-8 max-w-7xl mx-auto w-full">
                    <AdminSupportPage />
                </div>
            ) : activeView === 'payment-token' ? (
                <div className="flex-1 p-4 md:p-8 max-w-md mx-auto w-full">
                    <Card className="p-8 shadow-2xl">
                        <div className="flex items-center gap-4 mb-8">
                            <div className="p-3 bg-brand-50 rounded-2xl text-brand-600">
                                <DollarSign size={32} />
                            </div>
                            <div>
                                <h2 className="text-xl font-black text-surface-900 tracking-tight">Token de Pagamento</h2>
                                <p className="text-xs text-gray-500 font-bold uppercase tracking-widest">Configuração Global</p>
                            </div>
                        </div>
                        <PaymentTokenTab />
                    </Card>
                </div>
            ) : activeView === 'financial' ? (
                <div className="flex-1 p-4 md:p-8 max-w-7xl mx-auto w-full">
                    <div className="flex items-center justify-between mb-8">
                        <div>
                            <h2 className="text-2xl font-black text-surface-900 tracking-tight">Financeiro e Assinaturas</h2>
                            <p className="text-sm text-gray-400 font-bold uppercase tracking-widest">Controle de Faturamento Global</p>
                        </div>
                    </div>
                    <FinancialTab />
                </div>
            ) : activeView === 'connections' ? (
                <div className="flex-1 p-4 md:p-8 max-w-7xl mx-auto w-full">
                    <div className="flex items-center justify-between mb-8">
                        <div>
                            <h2 className="text-2xl font-black text-surface-900 tracking-tight">Gestão de Conexões</h2>
                            <p className="text-sm text-gray-400 font-bold uppercase tracking-widest">Monitoramento Evolution API</p>
                        </div>
                    </div>
                    <AdminConnectionsTab />
                </div>
            ) : (
                <main className="flex-1 p-4 md:p-8 max-w-7xl mx-auto w-full flex flex-col lg:grid lg:grid-cols-3 gap-6 md:gap-8">
                    {/* COLUNA: Cadastro e Estatísticas (Aparece depois no desktop, mas é importante no mobile) */}
                    <div className="lg:col-span-1 space-y-6 order-2 lg:order-1">
                        <Card className="p-6 shadow-xl shadow-brand-900/5">
                            <h2 className="text-lg font-black text-surface-900 mb-6 flex items-center gap-2">
                                <div className="p-2 bg-brand-50 rounded-lg"><Package className="text-brand-600" size={20} /></div>
                                Nova Loja
                            </h2>
                            <form onSubmit={handleCreateTenant} className="space-y-4">
                                <div>
                                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Nome da Loja</label>
                                    <input
                                        required
                                        className="input-primary w-full py-2.5"
                                        value={formData.store_name}
                                        onChange={e => {
                                            const name = e.target.value;
                                            const slug = frontendSlugify(name);
                                            setFormData({ ...formData, store_name: name, slug: slug });
                                            checkSlugAvailability(slug);
                                        }}
                                        placeholder="Ex: Essentique Perfumaria"
                                    />
                                </div>
                                <div>
                                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">WhatsApp (Padrão: 5511999999999)</label>
                                    <input
                                        required
                                        type="tel"
                                        className="input-primary w-full py-2.5"
                                        value={formData.phone}
                                        onChange={e => setFormData({ ...formData, phone: e.target.value.replace(/\D/g, '') })}
                                        placeholder="Ex: 5511999999999"
                                    />
                                </div>
                                <div>
                                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Slug (Identidade Única)</label>
                                    <div className="relative">
                                        <input
                                            required
                                            className={`input-primary w-full py-2.5 ${slugAvailable === false ? 'border-red-500' : slugAvailable === true ? 'border-emerald-500' : ''}`}
                                            value={formData.slug}
                                            onChange={e => {
                                                const slug = frontendSlugify(e.target.value);
                                                setFormData({ ...formData, slug });
                                                checkSlugAvailability(slug);
                                            }}
                                            placeholder="identidateloja"
                                        />
                                        <div className="absolute right-3 top-1/2 -translate-y-1/2">
                                            {checkingSlug ? (
                                                <div className="w-3 h-3 border-2 border-brand-500/30 border-t-brand-500 rounded-full animate-spin" />
                                            ) : slugAvailable === true ? (
                                                <CheckCircle size={14} className="text-emerald-500" />
                                            ) : slugAvailable === false ? (
                                                <XCircle size={14} className="text-red-500" />
                                            ) : null}
                                        </div>
                                    </div>
                                    {slugAvailable === false && <p className="text-[10px] text-red-500 font-bold mt-1">Este endereço já está em uso por outra loja</p>}
                                    {slugAvailable === true && <p className="text-[10px] text-emerald-600 font-bold mt-1">Endereço disponível!</p>}
                                </div>
                                <div><label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Nome do Dono</label><input required className="input-primary w-full py-2.5" value={formData.owner_name} onChange={e => setFormData({ ...formData, owner_name: e.target.value })} placeholder="Ex: Vinícius Matos" /></div>
                                <div><label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">E-mail de Acesso</label><input required type="email" className="input-primary w-full py-2.5" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} placeholder="contato@loja.com" /></div>
                                <div><label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Senha de Acesso</label><input required type="password" title="Mínimo 6 caracteres" className="input-primary w-full py-2.5" value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} placeholder="••••••" /></div>
                                <div><label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Plano Inicial</label>
                                    <select className="input-primary w-full py-2.5" value={formData.plan_type} onChange={e => setFormData({ ...formData, plan_type: e.target.value })}>
                                        <option value="BÁSICO">Básico (100 Produtos)</option>
                                        <option value="INTERMEDIÁRIO">Intermediário (300 Produtos)</option>
                                        <option value="PRO">Pro (Ilimitado)</option>
                                    </select>
                                </div>
                                <button disabled={loading} className="btn-primary w-full py-3 font-black shadow-lg shadow-brand-500/20 active:scale-95 transition-all">
                                    {loading ? 'Criando...' : 'Ativar Nova Loja'}
                                </button>
                            </form>
                        </Card>
                        <div className="bg-brand-600 p-6 rounded-2xl text-white shadow-xl shadow-brand-600/20 flex items-center justify-between overflow-hidden relative group">
                            <div className="absolute -right-4 -bottom-4 opacity-10 group-hover:scale-110 transition-transform"><Users size={100} /></div>
                            <div className="relative z-10">
                                <p className="text-[10px] font-black uppercase tracking-widest opacity-80 mb-1">Total de Tenants</p>
                                <span className="text-4xl font-black">{tenants.length}</span>
                            </div>
                            <div className="relative z-10 bg-white/20 px-3 py-1 rounded-full text-xs font-bold backdrop-blur-sm tracking-tighter">Lojas Ativas</div>
                        </div>
                    </div>

                    {/* COLUNA: Lista de Lojas Ativas */}
                    <div className="lg:col-span-2 order-1 lg:order-2">
                        <Card className="flex flex-col h-full min-h-[400px] lg:min-h-[80vh]">
                            <div className="p-4 md:p-6 border-b bg-surface-50/50 flex justify-between items-center">
                                <h2 className="font-black text-surface-900 flex items-center gap-2">
                                    <Users size={18} className="text-brand-600" /> Lojas Ativas
                                </h2>
                                <button onClick={loadTenants} className="text-[10px] font-black uppercase tracking-widest text-brand-600 hover:bg-brand-50 px-3 py-1.5 rounded-full border border-brand-100 transition-all">
                                    Atualizar Lista
                                </button>
                            </div>

                            <div className="overflow-y-auto flex-1">
                                {/* DESKTOP: Tabela tradicional para telas grandes */}
                                <div className="hidden md:block">
                                    <table className="w-full text-left">
                                        <thead className="bg-white sticky top-0 z-10 text-[10px] font-black text-gray-400 uppercase tracking-widest border-b">
                                            <tr>
                                                <th className="p-5">Loja / ID</th>
                                                <th className="p-5">Contato</th>
                                                <th className="p-5 text-center">Estatísticas</th>
                                                <th className="p-5 text-right">Gestão</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-surface-100">
                                            {tenants.map(t => (
                                                <tr key={t.id} className="hover:bg-surface-50 transition group">
                                                    <td className="p-5">
                                                        <div className="font-black text-surface-900">{t.name}</div>
                                                        <div className="text-[10px] font-mono text-gray-400 uppercase">ID: {t.id.slice(0, 8)}</div>
                                                    </td>
                                                    <td className="p-5">
                                                        <div className="text-brand-600 font-bold text-sm">{t.email}</div>
                                                        <a href={`/store/${t.id}`} target="_blank" className="text-[10px] font-black text-gray-400 hover:text-brand-500 uppercase tracking-tighter transition-colors">Ver Vitrine ↗</a>
                                                    </td>
                                                    <td className="p-5 text-center">
                                                        <div className="flex justify-center gap-2">
                                                            <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-gray-100 rounded-lg text-[10px] font-black text-gray-600" title="Produtos"><Package size={12} /> {t.product_count}</span>
                                                            <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-brand-50 rounded-lg text-[10px] font-black text-brand-600" title="Pedidos"><ShoppingBag size={12} /> {t.order_count}</span>
                                                        </div>
                                                    </td>
                                                    <td className="p-5 text-right">
                                                        <div className="flex justify-end gap-2">
                                                            <button onClick={() => setConfigTenantId(t.id)} className="p-2.5 bg-blue-50 text-blue-600 rounded-xl hover:bg-blue-100 transition-all shadow-sm"><Settings size={16} /></button>
                                                            <button onClick={() => handleDeleteTenant(t.id, t.name)} className="p-2.5 bg-red-50 text-red-500 rounded-xl hover:bg-red-100 transition-all shadow-sm"><Trash2 size={16} /></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* MOBILE: Cards empilhados para telas pequenas */}
                                <div className="md:hidden divide-y divide-gray-100">
                                    {tenants.length === 0 ? (
                                        <div className="p-10 text-center text-gray-400 text-sm">Nenhuma loja ativa encontrada.</div>
                                    ) : tenants.map(t => (
                                        <div key={t.id} className="p-4 space-y-4 active:bg-gray-50 transition">
                                            <div className="flex justify-between items-start">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-10 h-10 rounded-xl bg-brand-100 text-brand-700 flex items-center justify-center font-black text-xs uppercase shadow-sm">
                                                        {t.name.substring(0, 2)}
                                                    </div>
                                                    <div>
                                                        <h4 className="font-black text-surface-900 text-sm leading-tight">{t.name}</h4>
                                                        <p className="text-[10px] text-brand-600 font-bold">{t.email}</p>
                                                    </div>
                                                </div>
                                                <div className="flex gap-2">
                                                    <button onClick={() => setConfigTenantId(t.id)} className="p-2.5 bg-blue-50 text-blue-600 rounded-xl border border-blue-100"><Settings size={16} /></button>
                                                    <button onClick={() => handleDeleteTenant(t.id, t.name)} className="p-2.5 bg-red-50 text-red-500 rounded-xl border border-red-100"><Trash2 size={16} /></button>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-2">
                                                <div className="bg-surface-50 p-3 rounded-xl border border-surface-100">
                                                    <span className="block text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Catálogo</span>
                                                    <div className="flex items-center gap-1.5">
                                                        <Package size={14} className="text-gray-400" />
                                                        <span className="font-black text-surface-900 text-xs">{t.product_count} Produtos</span>
                                                    </div>
                                                </div>
                                                <div className="bg-surface-50 p-3 rounded-xl border border-surface-100">
                                                    <span className="block text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Vendas</span>
                                                    <div className="flex items-center gap-1.5">
                                                        <ShoppingBag size={14} className="text-brand-50" />
                                                        <span className="font-black text-brand-700 text-xs">{t.order_count} Pedidos</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex justify-between items-center pt-2">
                                                <span className="text-[9px] font-mono text-gray-300 uppercase">ID: {t.id.slice(0, 8)}</span>
                                                <a href={`/store/${t.id}`} target="_blank" className="bg-white px-4 py-2 rounded-lg border border-surface-200 text-[10px] font-black text-gray-500 uppercase tracking-widest shadow-sm no-underline">Vitrine ↗</a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div className="lg:col-span-3 text-center py-4">
                        <p className="text-[10px] text-gray-400">
                            Produto da família <a href="https://viniciusomatos.com/" target="_blank" rel="noreferrer" className="font-bold text-brand-600 hover:underline">Vinícius O Matos</a>
                        </p>
                    </div>
                </main>
            )}
        </div>
    );
};

// 5.5 Modal de Inserção de Saldo (Melhor Envio)
const AddBalanceModal = ({ tenantId, isOpen, onClose }: { tenantId: string, isOpen: boolean, onClose: () => void }) => {
    const { showToast } = useToast();
    const [amount, setAmount] = useState('50.00');
    const [method, setMethod] = useState<'pix' | 'boleto'>('pix');
    const [loading, setLoading] = useState(false);
    const [paymentResponse, setPaymentResponse] = useState<any>(null);

    const handleAddBalance = async () => {
        setLoading(true);
        try {
            const res = await axios.post(`https://zapshop.app/api/shipping/add-balance`, {
                tenantId,
                gateway: 'yapay-transparente',
                slug: method,
                value: parseFloat(amount)
            });
            setPaymentResponse(res.data);
        } catch (e) {
            showToast('Erro ao processar recarga. Verifique seu token e saldo.', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[60] p-4 animate-fade-in">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-scale-up">
                <div className="bg-gradient-to-r from-brand-600 to-brand-700 p-6 text-white flex justify-between items-center">
                    <div>
                        <h3 className="text-xl font-black">Recarregar Carteira</h3>
                        <p className="text-xs text-brand-100 font-medium">Melhor Envio Checkout</p>
                    </div>
                    <button onClick={() => { onClose(); setPaymentResponse(null); }} className="p-2 hover:bg-white/20 rounded-full transition-colors"><X size={24} /></button>
                </div>

                <div className="p-8">
                    {!paymentResponse ? (
                        <div className="space-y-6">
                            <div>
                                <label className="text-[10px] font-black uppercase text-gray-400 tracking-widest mb-2 block">Valor da Recarga (R$)</label>
                                <div className="relative">
                                    <span className="absolute left-4 top-1/2 -translate-y-1/2 font-bold text-gray-400">R$</span>
                                    <input
                                        type="number"
                                        step="0.01"
                                        className="w-full bg-gray-50 border-2 border-gray-100 rounded-2xl p-4 pl-12 text-2xl font-black text-gray-900 focus:border-brand-500 focus:bg-white transition-all outline-none"
                                        value={amount}
                                        onChange={e => setAmount(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="text-[10px] font-black uppercase text-gray-400 tracking-widest mb-3 block">Forma de Pagamento</label>
                                <div className="grid grid-cols-2 gap-3">
                                    <button
                                        onClick={() => setMethod('pix')}
                                        className={`flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all ${method === 'pix' ? 'border-brand-500 bg-brand-50 text-brand-700' : 'border-gray-100 text-gray-400 hover:border-gray-200'}`}
                                    >
                                        <div className={`p-2 rounded-lg ${method === 'pix' ? 'bg-brand-500 text-white' : 'bg-gray-100 text-gray-400'}`}>
                                            <Send size={20} />
                                        </div>
                                        <span className="font-bold text-sm">PIX</span>
                                    </button>
                                    <button
                                        onClick={() => setMethod('boleto')}
                                        className={`flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all ${method === 'boleto' ? 'border-brand-500 bg-brand-50 text-brand-700' : 'border-gray-100 text-gray-400 hover:border-gray-200'}`}
                                    >
                                        <div className={`p-2 rounded-lg ${method === 'boleto' ? 'bg-brand-500 text-white' : 'bg-gray-100 text-gray-400'}`}>
                                            <CreditCard size={20} />
                                        </div>
                                        <span className="font-bold text-sm">Boleto</span>
                                    </button>
                                </div>
                            </div>

                            <button
                                onClick={handleAddBalance}
                                disabled={loading || !amount}
                                className="w-full bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white font-black py-4 rounded-2xl shadow-xl shadow-brand-600/20 transition-all active:scale-95 flex items-center justify-center gap-2"
                            >
                                {loading ? <div className="w-6 h-6 border-3 border-white/30 border-t-white rounded-full animate-spin" /> : 'Confirmar e Gerar'}
                            </button>
                        </div>
                    ) : (
                        <div className="text-center space-y-6 py-4">
                            {method === 'pix' ? (
                                <>
                                    <div className="bg-emerald-50 text-emerald-600 p-4 rounded-2xl inline-flex items-center gap-2 mb-2">
                                        <CheckCircle size={20} /> <span className="font-bold">PIX Gerado!</span>
                                    </div>
                                    <div className="bg-white border-2 border-gray-100 p-2 rounded-xl inline-block shadow-sm">
                                        <img
                                            src={paymentResponse.redirect || paymentResponse.payment?.link || paymentResponse.qr_code || paymentResponse.qrcode}
                                            alt="QR Code PIX"
                                            className="w-32 h-32 mx-auto"
                                            onError={(e) => {
                                                (e.target as HTMLImageElement).style.display = 'none';
                                            }}
                                        />
                                        {!(paymentResponse.redirect || paymentResponse.payment?.link || paymentResponse.qr_code || paymentResponse.qrcode) && (
                                            <div className="w-32 h-32 flex items-center justify-center bg-gray-50 rounded-xl text-gray-400 text-[8px] text-center p-2 leading-tight">
                                                QR Code não disponível visualmente.<br />Use a chave abaixo.
                                            </div>
                                        )}
                                    </div>
                                    <div className="space-y-1.5 w-full max-w-xs mx-auto">
                                        <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">Copia e Cola:</p>
                                        <div className="bg-gray-50 p-2 rounded-lg border border-gray-100 relative group overflow-hidden">
                                            <p className="text-[9px] font-mono text-gray-400 break-all select-all leading-tight">
                                                {paymentResponse.digitable || paymentResponse.qrcode_text || paymentResponse.brcode || paymentResponse.text || 'Chave não localizada'}
                                            </p>
                                        </div>
                                        <button
                                            onClick={() => {
                                                const text = paymentResponse.digitable || paymentResponse.qrcode_text || paymentResponse.brcode || paymentResponse.text;
                                                if (text) {
                                                    navigator.clipboard.writeText(text);
                                                    showToast('Copiado para a área de transferência!', 'success');
                                                }
                                            }}
                                            className="text-[10px] bg-brand-50 text-brand-600 px-4 py-1.5 rounded-lg font-bold hover:bg-brand-100 transition-colors w-full"
                                        >
                                            Copiar Código PIX
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="bg-blue-50 text-blue-600 p-4 rounded-2xl inline-flex items-center gap-2">
                                        <CheckCircle size={20} /> <span className="font-bold">Boleto Gerado!</span>
                                    </div>
                                    <p className="text-gray-600 text-sm italic">Seu boleto foi gerado com sucesso. Use o link abaixo para pagar.</p>
                                    <a
                                        href={paymentResponse.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="w-full bg-brand-600 hover:bg-brand-700 text-white font-black py-4 rounded-2xl shadow-xl shadow-brand-600/20 transition-all inline-block mt-4"
                                    >
                                        Abrir Boleto (PDF)
                                    </a>
                                </>
                            )}
                            <button
                                onClick={() => { onClose(); setPaymentResponse(null); }}
                                className="text-gray-400 font-bold hover:text-gray-600 transition-colors pt-4 block w-full"
                            >
                                Fechar Janela
                            </button>
                            <div className="pt-2 text-center">
                                <a
                                    href="https://www.melhorenvio.com.br/painel/carteira"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-[10px] text-brand-500 hover:text-brand-700 font-bold uppercase tracking-widest"
                                >
                                    Abrir Painel do Melhor Envio ↗
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


// --- ABA: WHATSAPP (LOJISTA) ---
const WhatsAppTab = ({ tenantId, slug }: { tenantId: string, slug: string }) => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [loading, setLoading] = useState(true);
    const [connecting, setConnecting] = useState(false);
    const [data, setData] = useState<any>(null);
    const [qrCode, setQrCode] = useState<string | null>(null);
    const [timer, setTimer] = useState(60);

    const loadStatus = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/whatsapp/status`);
            setData(res.data);
        } catch (error) {
            console.error('Erro ao buscar status do WhatsApp', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadStatus();
        const interval = setInterval(loadStatus, 20000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        let timerInterval: any;
        let pollInterval: any;

        if (qrCode && timer > 0) {
            timerInterval = setInterval(() => setTimer(t => t - 1), 1000);

            // Polling rápido a cada 2.5s enquanto o QR Code está na tela para detectar a leitura imediatamente
            pollInterval = setInterval(async () => {
                try {
                    const res = await axios.get(`${API_BASE_URL}/whatsapp/status`);
                    if (res.data?.whatsapp_status === 'open') {
                        setData(res.data);
                        setQrCode(null);
                        setTimer(60);
                        showToast('WhatsApp conectado com sucesso!', 'success');
                    }
                } catch (e) {
                    // ignorar erro transitório de polling
                }
            }, 2500);
        } else if (timer === 0) {
            setQrCode(null);
            setTimer(60);
        }

        return () => {
            clearInterval(timerInterval);
            clearInterval(pollInterval);
        };
    }, [qrCode, timer]);

    const handleConnect = async () => {
        setConnecting(true);
        try {
            // Verifica primeiro se já não está conectado
            const statusRes = await axios.get(`${API_BASE_URL}/whatsapp/status`);
            if (statusRes.data?.whatsapp_status === 'open') {
                setData(statusRes.data);
                showToast('WhatsApp já está conectado!', 'success');
                setConnecting(false);
                return;
            }

            const res = await axios.post('https://2n8n.viniciusomatos.com/webhook/whatsapp-manager', {
                tenant_id: tenantId,
                slug: slug.replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase()
            });

            // Suporta o formato antigo (qrcode) e os formatos da Evolution API (data.base64, base64, qrcode)
            const qr = res.data?.qrcode || res.data?.data?.base64 || res.data?.base64 || res.data?.data?.qrcode;

            if (qr) {
                setQrCode(qr);
                setTimer(60);
            } else if (res.data?.whatsapp_status === 'open' || res.data?.status === 'open' || res.data?.connectionStatus === 'open') {
                showToast('WhatsApp conectado com sucesso!', 'success');
                loadStatus();
            } else {
                // Tenta recarregar o status caso a conexão tenha acabado de abrir
                const fresh = await axios.get(`${API_BASE_URL}/whatsapp/status`);
                if (fresh.data?.whatsapp_status === 'open') {
                    setData(fresh.data);
                    showToast('WhatsApp conectado com sucesso!', 'success');
                } else {
                    showToast('Ocorreu um erro ao gerar o QR Code. Tente novamente.', 'error');
                }
            }
        } catch (error) {
            showToast('Erro ao conectar com o servidor.', 'error');
        } finally {
            setConnecting(false);
        }
    };

    const handleDisconnect = async () => {
        if (!(await confirm({
            title: 'Desconectar WhatsApp',
            message: 'Deseja realmente desconectar seu WhatsApp?',
            type: 'danger'
        }))) return;
        setConnecting(true);
        try {
            await axios.post(`${API_BASE_URL}/whatsapp/disconnect`);
            showToast('WhatsApp desconectado!', 'info');
            loadStatus();
        } catch (error) {
            console.error('Erro ao desconectar WhatsApp', error);
            showToast('Erro ao desconectar. Tente novamente.', 'error');
        } finally {
            setConnecting(false);
        }
    };

    if (loading) return <div className="p-12 text-center text-gray-400 animate-pulse">Carregando status do WhatsApp...</div>;

    const isConnected = data?.whatsapp_status === 'open';

    return (
        <div className="space-y-6 animate-fade-in max-w-2xl mx-auto">
            <Card className="p-8 text-center">
                <div className="mb-6 flex justify-center">
                    <div className={`p-5 rounded-3xl ${isConnected ? 'bg-emerald-50 text-emerald-600' : 'bg-gray-50 text-gray-400'}`}>
                        <MessageCircle size={48} />
                    </div>
                </div>

                <h3 className="text-2xl font-black text-surface-900 mb-2">WhatsApp Multi-tenant</h3>
                <p className="text-gray-500 mb-8 max-w-sm mx-auto">
                    Conecte seu WhatsApp para automatizar notificações de pedidos e usar a IA para atender seus clientes.
                </p>

                {isConnected ? (
                    <div className="space-y-6">
                        <div className="bg-emerald-50 border border-emerald-100 p-4 rounded-2xl flex items-center justify-center gap-3 text-emerald-700">
                            <CheckCircle size={20} />
                            <span className="font-bold">WhatsApp Conectado com Sucesso!</span>
                        </div>
                        <div className="text-left bg-surface-50 p-4 rounded-2xl border border-surface-100">
                            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">Instância Ativa</p>
                            <p className="font-mono text-xs text-surface-600 mb-4">{data.whatsapp_instance}</p>

                            <button
                                onClick={handleDisconnect}
                                disabled={connecting}
                                className="text-red-600 text-xs font-bold hover:underline flex items-center gap-1 mx-auto disabled:opacity-50"
                            >
                                <LogOut size={14} /> {connecting ? 'Desconectando...' : 'Desconectar este número'}
                            </button>
                        </div>
                    </div>
                ) : qrCode ? (
                    <div className="space-y-6">
                        <div className="bg-white border-4 border-brand-100 p-4 rounded-3xl inline-block shadow-xl">
                            <img src={qrCode} alt="WhatsApp QR Code" className="w-64 h-64 mx-auto" />
                        </div>
                        <div className="flex flex-col items-center">
                            <div className="flex items-center gap-2 text-brand-600 font-black text-xl mb-1">
                                <Clock size={20} /> {timer}s
                            </div>
                            <p className="text-xs text-gray-400">Escaneie o código acima com seu WhatsApp</p>
                        </div>
                        <button onClick={() => setQrCode(null)} className="text-gray-400 text-xs font-bold hover:text-gray-600">
                            Cancelar e voltar
                        </button>
                    </div>
                ) : (
                    <button
                        onClick={handleConnect}
                        disabled={connecting}
                        className="w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-black py-4 rounded-2xl shadow-xl shadow-green-600/20 transition-all active:scale-95 flex items-center justify-center gap-2"
                    >
                        {connecting ? (
                            <div className="w-6 h-6 border-3 border-white/30 border-t-white rounded-full animate-spin" />
                        ) : (
                            <><MessageCircle size={20} /> Conectar WhatsApp</>
                        )}
                    </button>
                )}
            </Card>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Card className="p-5 border-l-4 border-brand-500">
                    <h4 className="font-bold text-surface-900 mb-2 h-10 flex items-center gap-2">
                        <Bot size={18} className="text-brand-500" /> IA Atendente
                    </h4>
                    <p className="text-xs text-gray-500">Com o WhatsApp conectado, nossa IA poderá responder dúvidas sobre produtos e estoque 24h por dia.</p>
                </Card>
                <Card className="p-5 border-l-4 border-emerald-500">
                    <h4 className="font-bold text-surface-900 mb-2 h-10 flex items-center gap-2">
                        <ShoppingBag size={18} className="text-emerald-500" /> Fluxo de Pedidos
                    </h4>
                    <p className="text-xs text-gray-500">Seus clientes receberão o link de pagamento e atualizações de status diretamente no WhatsApp.</p>
                </Card>
            </div>
        </div>
    );
};

// --- ABA: GESTÃO DE CONEXÕES (SUPER ADMIN) ---
const AdminConnectionsTab = () => {
    const { showToast } = useToast();
    const { confirm } = useConfirm();
    const [connections, setConnections] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [syncing, setSyncing] = useState(false);
    const [syncResult, setSyncResult] = useState<string | null>(null);

    const loadConnections = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/admin/whatsapp/connections`);
            setConnections(res.data);
        } catch (error) {
            console.error('Erro ao buscar conexões', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadConnections(); }, []);

    const handleSyncGlobal = async () => {
        if (syncing) return;
        setSyncing(true);
        setSyncResult(null);
        try {
            const res = await axios.post(`${API_BASE_URL}/admin/whatsapp/sync-global`);
            setSyncResult(res.data.message || 'Sync concluído!');
            loadConnections();
        } catch (error: any) {
            setSyncResult('Erro: ' + (error.response?.data?.error || error.message));
        } finally {
            setSyncing(false);
        }
    };

    const handleAction = async (action: 'logout' | 'restart', tenantId: string) => {
        if (!(await confirm({
            title: action === 'logout' ? 'Forçar Logout' : 'Reiniciar Instância',
            message: `Deseja realmente ${action === 'logout' ? 'desconectar' : 'reiniciar'} esta instância?`,
            type: action === 'logout' ? 'danger' : 'warning'
        }))) return;

        try {
            await axios.post(`${API_BASE_URL}/admin/whatsapp/${action}/${tenantId}`);
            showToast('Comando enviado com sucesso!', 'success');
            loadConnections();
        } catch (error) {
            showToast('Erro ao enviar comando.', 'error');
        }
    };

    if (loading) return <div className="p-12 text-center text-gray-500 animate-pulse">Carregando conexões...</div>;

    return (
        <Card className="overflow-hidden">
            <div className="p-4 bg-surface-50 border-b flex flex-wrap justify-between items-center gap-3">
                <h3 className="font-black text-surface-900 flex items-center gap-2">
                    <QrCode size={18} className="text-brand-600" /> Status Global das Instâncias
                </h3>
                <div className="flex items-center gap-2">
                    {syncResult && (
                        <span className="text-xs text-gray-500 font-medium max-w-xs truncate">{syncResult}</span>
                    )}
                    <button
                        onClick={handleSyncGlobal}
                        disabled={syncing}
                        className="flex items-center gap-2 px-3 py-1.5 bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white text-xs font-black rounded-lg transition-all"
                        title="Sincroniza todas as instâncias em lotes de 5 com delay de 1s entre cada lote"
                    >
                        {syncing ? (
                            <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        ) : (
                            <RefreshCw size={14} />
                        )}
                        {syncing ? 'Sincronizando...' : 'Sync Global'}
                    </button>
                    <button onClick={loadConnections} className="p-2 hover:bg-gray-200 rounded-lg transition-colors" title="Recarregar lista">
                        <RefreshCw size={16} className="text-gray-500" />
                    </button>
                </div>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="bg-white text-[10px] font-black text-gray-400 uppercase tracking-widest border-b">
                        <tr>
                            <th className="p-5">Lojista</th>
                            <th className="p-5">Instância</th>
                            <th className="p-5">Status</th>
                            <th className="p-5">Última Ativ.</th>
                            <th className="p-5 text-right">Ações</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-surface-100">
                        {connections.length === 0 ? (
                            <tr><td colSpan={5} className="p-10 text-center text-gray-400">Nenhuma conexão registrada.</td></tr>
                        ) : connections.map(c => (
                            <tr key={c.id} className="hover:bg-surface-50 transition">
                                <td className="p-5">
                                    <div className="font-bold text-surface-900">{c.store_name}</div>
                                    <div className="text-[10px] text-gray-400 uppercase">{c.id.slice(0, 8)}</div>
                                </td>
                                <td className="p-5 font-mono text-xs">{c.whatsapp_instance || '-'}</td>
                                <td className="p-5">
                                    <Badge color={c.whatsapp_status === 'open' ? 'green' : 'gray'}>
                                        {c.whatsapp_status?.toUpperCase() || 'OFFLINE'}
                                    </Badge>
                                </td>
                                <td className="p-5 text-xs text-gray-500">{c.updated_at ? new Date(c.updated_at).toLocaleString('pt-BR') : '-'}</td>
                                <td className="p-5 text-right">
                                    <div className="flex justify-end gap-2">
                                        <button onClick={() => handleAction('restart', c.id)} className="p-2 bg-amber-50 text-amber-600 rounded-lg hover:bg-amber-100" title="Reiniciar"><RefreshCw size={14} /></button>
                                        <button onClick={() => handleAction('logout', c.id)} className="p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100" title="Forçar Logout"><LogOut size={14} /></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
};
const ShippingTab = ({ tenantId, onGoToSettings }: { tenantId: string, onGoToSettings: () => void }) => {
    const { showToast } = useToast();
    const [balance, setBalance] = useState<any>(null);
    const [services, setServices] = useState<any[]>([]);
    const [enabledServices, setEnabledServices] = useState<string[]>([]);
    const [token, setToken] = useState('');
    const [originZip, setOriginZip] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [isBalanceModalOpen, setIsBalanceModalOpen] = useState(false);

    useEffect(() => {
        const handleHash = () => {
            if (window.location.hash === '#shipping-recharge') {
                setIsBalanceModalOpen(true);
                window.location.hash = 'shipping';
            }
        };
        handleHash();
        window.addEventListener('hashchange', handleHash);
        return () => window.removeEventListener('hashchange', handleHash);
    }, []);

    const loadShippingData = async () => {
        setLoading(true);
        try {
            // 1. Obter configs salvas
            const tenantRes = await axios.get(`https://zapshop.app/api/admin/tenant/${tenantId}`);
            const t = tenantRes.data;
            const savedConfig = t.shipping_config || {};
            setToken(savedConfig.token || '');
            setEnabledServices(savedConfig.enabled_services || []);
            setOriginZip(t.origin_zip_code || '');

            if (savedConfig.token) {
                // 2. Obter Balance e Info
                try {
                    const meRes = await axios.get(`https://zapshop.app/api/shipping/me?tenant_id=${tenantId}`);
                    setBalance(meRes.data);
                } catch (e) {
                    console.error("Erro ao buscar ME info", e);
                }

                // 3. Listar Servicos Disponiveis
                try {
                    const servRes = await axios.get(`https://zapshop.app/api/shipping/services?tenant_id=${tenantId}`);
                    setServices(servRes.data);
                } catch (e) {
                    console.error("Erro ao buscar ME Services", e);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadShippingData(); }, [tenantId]);

    const handleSaveConfig = async () => {
        if (!token) {
            showToast('Por favor, insira o token do Melhor Envio.', 'error');
            return;
        }
        setSaving(true);
        try {
            await axios.put(`https://zapshop.app/api/admin/tenant/${tenantId}/shipping-config`, {
                token,
                enabled_services: enabledServices
            });
            showToast('Configurações de Envio Salvas!', 'success');
            loadShippingData(); // refresh
        } catch (e) {
            showToast('Erro ao salvar as configurações.', 'error');
        } finally {
            setSaving(false);
        }
    };

    const toggleService = (id: string) => {
        if (enabledServices.includes(id)) {
            setEnabledServices(enabledServices.filter(s => s !== id));
        } else {
            setEnabledServices([...enabledServices, id]);
        }
    };

    if (loading) return <div className="p-10 text-center text-gray-500">Carregando Envios...</div>;

    return (
        <div className="space-y-6 animate-fade-in max-w-4xl mx-auto">
            {/* Aviso de CEP de Origem Ausente */}
            {!originZip && (
                <div className="bg-amber-50 border border-amber-200 p-4 rounded-xl flex flex-col md:flex-row items-center justify-between gap-4 shadow-sm">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center text-amber-600">
                            <MapPin size={20} />
                        </div>
                        <div>
                            <p className="font-bold text-amber-900 leading-tight">Configuração Pendente!</p>
                            <p className="text-xs text-amber-700">O seu CEP de origem não foi configurado. Isso é obrigatório para o cálculo de frete.</p>
                        </div>
                    </div>
                    <button
                        onClick={onGoToSettings}
                        className="bg-amber-600 text-white px-4 py-2 rounded-lg text-xs font-black shadow-lg shadow-amber-600/20 hover:bg-amber-700 transition-all flex items-center gap-2 whitespace-nowrap"
                    >
                        Configurar CEP agora <ChevronRight size={14} />
                    </button>
                </div>
            )}

            <Card className="p-6">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2 mb-6 border-b border-gray-100 pb-4">
                    <Truck size={24} className="text-brand-600" /> Integração Melhor Envio
                </h3>

                <div className="space-y-4 mb-6">
                    <label className="block text-sm font-bold text-gray-600 mb-1">Token Melhor Envio (Produção)</label>
                    <input
                        type="password"
                        className="input-primary w-full p-2 border rounded"
                        value={token}
                        onChange={e => setToken(e.target.value)}
                        placeholder="Insira seu Bearer Token do Melhor Envio..."
                    />
                    <p className="text-xs text-gray-500">
                        Você precisa autorizar o ZapShop no painel do Melhor Envio e inserir o token de acesso (OAuth) aqui.
                    </p>
                </div>

                {balance && (
                    <div className="bg-gradient-to-br from-brand-600 to-brand-800 p-6 rounded-2xl shadow-xl shadow-brand-500/20 flex flex-col md:flex-row items-center justify-between gap-6 mb-8 text-white">
                        <div className="flex items-center gap-4 w-full md:w-auto">
                            <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/30 text-2xl font-black">
                                {balance.company_name?.substring(0, 2) || 'ME'}
                            </div>
                            <div>
                                <p className="text-[10px] font-black uppercase tracking-widest text-brand-100">Carteira Conectada</p>
                                <h4 className="text-xl font-black leading-none mb-1">{balance.company_name || 'Usuário Melhor Envio'}</h4>
                                <p className="text-xs text-brand-200 font-medium">{balance.email}</p>
                            </div>
                        </div>

                        <div className="flex flex-col md:items-end w-full md:w-auto text-left md:text-right border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0 md:pl-8">
                            <p className="text-[10px] font-black uppercase tracking-widest text-brand-100 mb-1">Saldo Disponível</p>
                            <h3 className="text-3xl font-black mb-3">R$ {Number(balance.balance).toFixed(2).replace('.', ',')}</h3>
                            <button
                                onClick={() => setIsBalanceModalOpen(true)}
                                className="bg-white text-brand-700 px-6 py-2.5 rounded-xl font-bold text-sm hover:bg-brand-50 transition-all flex items-center justify-center gap-2 active:scale-95 shadow-lg shadow-white/10"
                            >
                                <Plus size={18} /> Adicionar Saldo
                            </button>
                        </div>
                    </div>
                )}

                <AddBalanceModal
                    tenantId={tenantId}
                    isOpen={isBalanceModalOpen}
                    onClose={() => setIsBalanceModalOpen(false)}
                />

                {token && (
                    <div>
                        <h4 className="font-bold text-gray-800 flex items-center gap-2 mb-4">
                            <Box size={18} className="text-gray-400" /> Transportadoras Disponíveis
                        </h4>
                        <p className="text-xs text-gray-500 mb-4">Selecione quais serviços você deseja exibir para cálculo de frete no checkout do cliente.</p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-h-96 overflow-y-auto pr-2 custom-scrollbar">
                            {services.length === 0 ? <p className="text-sm text-gray-400">Nenhum serviço mapeado. Verifique seu token.</p> :
                                services.map(s => {
                                    const checked = enabledServices.includes(String(s.id));
                                    return (
                                        <label key={s.id} className={`flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-colors ${checked ? 'border-brand-500 bg-brand-50/50' : 'border-surface-200 hover:bg-surface-50'}`}>
                                            <input
                                                type="checkbox"
                                                className="w-5 h-5 rounded text-brand-600 accent-brand-600"
                                                checked={checked}
                                                onChange={() => toggleService(String(s.id))}
                                            />
                                            <div className="flex-1">
                                                <div className="flex justify-between items-center">
                                                    <span className="font-bold text-sm text-surface-900">{s.company.name}</span>
                                                    <span className="text-[10px] font-bold text-gray-400 uppercase bg-gray-100 px-2 py-0.5 rounded">{s.type}</span>
                                                </div>
                                                <span className="text-xs text-gray-500">{s.name}</span>
                                            </div>
                                        </label>
                                    );
                                })
                            }
                        </div>
                    </div>
                )}

                <div className="pt-6 mt-6 border-t border-gray-100">
                    <button
                        onClick={handleSaveConfig}
                        disabled={saving}
                        className="w-full bg-brand-600 hover:bg-brand-700 text-white font-bold py-3 rounded-xl shadow-lg shadow-brand-600/20 transition flex items-center justify-center gap-2"
                    >
                        <Save size={18} /> {saving ? 'Salvando...' : 'Salvar Configurações de Envio'}
                    </button>
                </div>
            </Card>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Card className="p-5 border-l-4 border-amber-400">
                    <h4 className="font-bold flex items-center gap-2 text-amber-700 mb-2">
                        <HelpCircle size={18} /> Como começar?
                    </h4>
                    <p className="text-xs text-gray-600 mb-4">
                        Aprenda a gerar seu token e configurar sua conta passo a passo no tutorial oficial.
                    </p>
                    <a
                        href="https://centraldeajuda.melhorenvio.com.br/hc/pt-br/articles/31220726011284-O-que-%C3%A9-um-token-e-para-o-que-ele-%C3%A9-usado-nas-integra%C3%A7%C3%B5es-do-Melhor-Envio#01JJD1H5MQ8Z1HN1JMZCGC09RY"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-bold py-2.5 px-4 rounded-xl text-xs transition-all shadow-lg shadow-amber-500/20 active:scale-95"
                    >
                        <Send size={14} /> Ver Tutorial Completo
                    </a>
                </Card>
                <Card className="p-5 border-l-4 border-blue-400">
                    <h4 className="font-bold flex items-center gap-2 text-blue-700 mb-2">
                        <Truck size={18} /> Emissão de Etiquetas
                    </h4>
                    <p className="text-xs text-gray-600 mb-2">
                        Após configurar tudo, vá até a aba de <strong>Pedidos</strong> e clique no ícone de despacho 🚀 para gerar a etiqueta automaticamente.
                    </p>
                    <p className="text-[10px] text-gray-400">
                        O valor da etiqueta será debitado do seu saldo do Melhor Envio no momento da geração.
                    </p>
                </Card>
            </div>
        </div>
    );
};

// --- TENANT VIEW (LAYOUT) ---
const TenantView = ({ tenantId, user }: { tenantId: string, user: any }) => {
    const [activeTab, setActiveTab] = useState('overview');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<any>(null);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [stats, setStats] = useState({ products: 0, orders: 0, sales: 0 });
    const [storeData, setStoreData] = useState<any>(null);
    const [trackingModalOpen, setTrackingModalOpen] = useState(false);
    const [orderToTrack, setOrderToTrack] = useState<any>(null);
    const [termsAccepted, setTermsAccepted] = useState(user?.terms_accepted || false);

    const loadAllData = async () => {
        if (!tenantId) return;
        try {
            const [store, statsRes] = await Promise.all([
                getStoreInfo(tenantId),
                axios.get(`https://zapshop.app/api/dashboard/stats/${tenantId}`)
            ]);
            setStoreData(store);
            setStats(statsRes.data);
        } catch (e) { console.error(e); }
    };

    useEffect(() => { loadAllData(); }, [tenantId]);

    useEffect(() => {
        const handleHash = () => {
            const hash = window.location.hash;
            if (hash.startsWith('#shipping')) {
                setActiveTab('shipping');
            } else if (hash === '#orders') {
                setActiveTab('orders');
            } else if (hash === '#overview') {
                setActiveTab('overview');
            } else if (hash === '#subscription') {
                setActiveTab('subscription');
            } else if (hash === '#settings') {
                setActiveTab('settings');
            } else if (hash === '#prompts') {
                setActiveTab('prompts');
            }

        };
        handleHash(); // Run on mount
        window.addEventListener('hashchange', handleHash);
        return () => window.removeEventListener('hashchange', handleHash);
    }, []);

    const handleShareStore = () => {
        setIsShareModalOpen(true);
    };

    const menuItems = [
        { id: 'overview', label: 'Visão Geral', icon: LayoutDashboard },
        { id: 'orders', label: 'Pedidos', icon: ShoppingBag },
        { id: 'customers', label: 'Clientes', icon: Users },
        { id: 'products', label: 'Gerir Produtos', icon: Package },
        { id: 'coupons', label: 'Cupons de Desconto', icon: TicketPercent },
        { id: 'shipping', label: 'Envios', icon: Truck },
        { id: 'prompts', label: 'Prompts da IA', icon: Bot },
        { id: 'whatsapp', label: 'WhatsApp', icon: MessageCircle },

        { id: 'reports', label: 'Relatórios', icon: BarChart3 },
        { id: 'subscription', label: 'Mensalidade', icon: DollarSign },
        { id: 'settings', label: 'Configurações', icon: Settings },
        { id: 'support', label: 'Suporte', icon: HelpCircle },
    ];

    return (
        <div className="flex h-screen bg-surface-50 font-sans text-surface-900 overflow-hidden">

            {/* BACKDROP: Fecha o menu ao clicar fora no celular */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-surface-900/50 backdrop-blur-sm z-40 md:hidden transition-opacity"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-surface-200 transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 flex flex-col shadow-xl md:shadow-none`}>
                <div className="h-24 flex items-center justify-center border-b border-surface-100"><img src="/logozapshopsaas.png" alt="ZapShop" className="h-20 w-auto object-contain" /></div>
                <nav className="flex-1 px-4 py-8 space-y-1 overflow-y-auto">{menuItems.map(item => { const active = activeTab === item.id; return (<button key={item.id} onClick={() => { setActiveTab(item.id); setSidebarOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 group ${active ? 'bg-brand-50 text-brand-700 shadow-sm' : 'text-gray-500 hover:bg-surface-50 hover:text-surface-900'}`}><item.icon size={20} className={`transition-colors ${active ? 'text-brand-600' : 'text-gray-400 group-hover:text-surface-600'}`} /> {item.label} {active && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-brand-600" />}</button>); })}</nav>
                <div className="p-4 border-t border-surface-100 bg-surface-50/50">
                    <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-brand-600 to-secondary-500 text-white flex items-center justify-center font-bold shadow-md">{user.name.charAt(0)}</div>
                        <div className="overflow-hidden">
                            <p className="text-sm font-bold text-surface-900 truncate">{user.name}</p>
                            <p className="text-xs text-gray-500 truncate">{user.email}</p>
                        </div>
                    </div>
                    <button onClick={() => { localStorage.clear(); window.location.href = '/login' }} className="w-full py-2 text-xs font-bold text-red-600 hover:bg-red-50 rounded-lg transition border border-transparent hover:border-red-100 flex items-center justify-center gap-2 mb-3">
                        <LogOut size={14} /> Sair
                    </button>
                    <p className="text-[10px] text-center text-gray-400">
                        Produto da família <a href="https://viniciusomatos.com/" target="_blank" rel="noreferrer" className="font-bold text-brand-600 hover:underline">Vinícius O Matos</a>
                    </p>
                </div>
            </aside>

            <main className="flex-1 md:ml-64 flex flex-col h-full overflow-hidden relative">
                <header className="h-16 md:h-20 flex items-center justify-between px-4 md:px-8 bg-white/80 backdrop-blur-sm border-b border-surface-200 sticky top-0 z-40">
                    <div className="flex items-center gap-3">
                        <button onClick={() => setSidebarOpen(true)} className="md:hidden p-2 hover:bg-surface-100 rounded-lg"><Menu className="text-gray-600" size={24} /></button>
                        <h2 className="text-xl md:text-2xl font-bold text-surface-900 tracking-tight truncate">{menuItems.find(i => i.id === activeTab)?.label}</h2>
                    </div>
                    <div className="flex items-center gap-2">
                        <button onClick={handleShareStore} className="bg-surface-100 text-surface-700 py-2 px-3 md:px-4 rounded-xl text-sm font-semibold hover:bg-surface-200 transition-colors flex items-center gap-2">
                            <Share2 size={18} /> <span className="hidden sm:inline">Compartilhar</span>
                        </button>
                        <a
                            href={storeData?.custom_domain && storeData?.custom_domain_status === 'active' ? `https://${storeData.custom_domain}` : `/store/${storeData?.slug || tenantId}`}
                            target="_blank"
                            className="btn-primary py-2 px-3 md:px-5 text-sm shadow-brand-500/30 hover:shadow-brand-500/40 flex items-center gap-2"
                        >
                            <ShoppingBag size={18} /> <span className="hidden sm:inline">Ver Loja</span>
                        </a>
                    </div>
                </header>
                <div className="flex-1 overflow-y-auto p-8">
                    <div className="max-w-7xl mx-auto pb-10">
                        {activeTab === 'overview' && <OverviewTab stats={stats} tenantId={tenantId} onOpenOrderDetails={(o: any) => { setSelectedOrder(o); setIsDetailsModalOpen(true); }} />}
                        {activeTab === 'orders' && <OrdersTab tenantId={tenantId} onOpenOrderDetails={(o: any) => { setSelectedOrder(o); setIsDetailsModalOpen(true); }} />}
                        {activeTab === 'customers' && <CustomersTab tenantId={tenantId} />}
                        {activeTab === 'products' && <AdminProducts />}
                        {activeTab === 'coupons' && <CouponsTab tenantId={tenantId} />}
                        {activeTab === 'shipping' && <ShippingTab tenantId={tenantId} onGoToSettings={() => setActiveTab('settings')} />}
                        {activeTab === 'prompts' && <PromptsTab tenantId={tenantId} />}
                        {activeTab === 'whatsapp' && <WhatsAppTab tenantId={tenantId} slug={storeData?.slug || ''} />}

                        {activeTab === 'reports' && <ReportsTab tenantId={tenantId} />}
                        {activeTab === 'subscription' && <SubscriptionTab tenantId={tenantId} />}
                        {activeTab === 'settings' && <SettingsTab tenantId={tenantId} initialData={storeData} onSuccess={loadAllData} />}
                        {activeTab === 'support' && <SupportPage />}
                    </div>
                </div>
            </main>
            <ShareModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                url={`https://zapshop.app/store/${storeData?.slug || tenantId}`}
                title={storeData?.name || 'ZapShop'}
            />
            {!termsAccepted && user.role !== 'SUPER_ADMIN' && (
                <TermsOfUseModal
                    tenantId={tenantId}
                    onAccept={() => {
                        setTermsAccepted(true);
                        // Atualiza o cache do auth para evitar refresh
                        const auth = JSON.parse(localStorage.getItem('zapshop_auth') || '{}');
                        auth.terms_accepted = true;
                        localStorage.setItem('zapshop_auth', JSON.stringify(auth));
                    }}
                />
            )}
            {isDetailsModalOpen && <OrderDetailsModal isOpen={isDetailsModalOpen} onClose={() => setIsDetailsModalOpen(false)} order={selectedOrder} />}
        </div>
    );
};

const AdminDashboard = () => {
    const user = getAuth();
    if (!user) return <div className="h-screen flex items-center justify-center"><div className="w-8 h-8 border-4 border-brand-600 border-t-transparent rounded-full animate-spin"></div></div>;
    if (user.role === 'SUPER_ADMIN') return <SuperAdminView user={user} />;
    return <TenantView tenantId={user.tenant_id} user={user} />;
};

export default AdminDashboard;
